<template>
    <div>
        <v-dialog light persistent v-model="filtroDialog" width="340px" scrollable style="max-width:340px;">
            <v-layout align-center column justify-center class="cardStats" style="height:100%">
                <v-flex v-if="isMultiDivisione()" flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                    <v-select :items="listaDivisioni" v-model="divisioneSelected" :label="'Divisione'" single-line persistent-hint :hint="'Divisione'" @input="changedDivisione"></v-select>
                </v-flex>
                <v-flex flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                    <v-select :items="listaSesso" v-model="sessoSelected" :label="'Sesso'" single-line persistent-hint :hint="'Sesso'" @input="changedSex"></v-select>
                </v-flex>
                <v-flex flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                    <v-select :items="listaCategorie" v-model="categoriaSelected" :label="'Categoria'" single-line persistent-hint :hint="'Categoria'" @input="changedCategoria"></v-select>
                </v-flex>
                <v-flex  v-if="mostraNazione" flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                    <v-select :items="listaNazioni" v-model="nazioneSelected" :label="'- seleziona nazione - '" single-line persistent-hint :hint="'Nazione'" @input="changedNazione"></v-select>
                </v-flex>
                <v-flex flex xs12 sm12 md12 lg12 class="mb-4 pa-2" style="width:100%">
                    <v-layout align-start row wrap justify-center class="mt-1">
                        <v-btn small round outline class="red--text" @click="annullaFiltro()">Annulla filtro</v-btn>
                        <v-btn small round outline class="green--text" @click="filtroDialog=false">Applica</v-btn>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-dialog>
        <v-dialog light persistent v-model="dettaglio" class="cardUp" width="800px" scrollable style="max-width:800px;">
            <v-layout align-center column justify-center class="cardStats" style="height:100%">
                <table v-if="currentItem != undefined" style="width: 100%" class="">
                    <tr>
                        <td width="70%" class="cardStatsHeader  pa-1" colspan=4>
                            <strong style="float: left">
                                <span class="mr-2 ml-1 white--text">{{ currentItem.pett }}</span>
    
                                <country-flag :country="currentItem.nazione" size="small" class="" />
                                {{currentItem.cognome }}  {{ currentItem.nome }}
                                <br />
                                <span class="ml-5"><small>{{ currentItem.squadra }} </small></span>
                            </strong>
                            <v-icon @click="dettaglio=false" class="ma-0 pa-0 white--text" style="float:right">close</v-icon>
                        </td>
                    </tr>
                </table>
                <table v-if="currentItem != undefined" style="width: 100%" class="mb-3">
                    <tr>
                        <td width="30%" class="pr-2 frazioniTitle frazioniValueR">Divisione</td>
                        <td width="70%" class="frazioniValue"><strong>{{currentItem.divisione }}</strong></td>
                    </tr>
                    <tr>
                        <td class="pr-2 frazioniTitle frazioniValueR">Pos. Ass.</td>
                        <td class="backColor"><strong>{{currentItem.posAss }}°</strong></td>
                    </tr>
                    <tr>
                        <td class="pr-2 frazioniTitle frazioniValueR">Pos. Div.</td>
                        <td class="frazioniValue "><strong>{{currentItem.posDiv }}°</strong></td>
                    </tr>
                    <tr>
                        <td class="pr-2 frazioniTitle frazioniValueR">Pos. Cat.</td>
                        <td class="backColor "><strong>{{currentItem.posCat }}°</strong> - Cat: {{currentItem.categoria }} </td>
                    </tr>
                    <tr v-if="showMedia">
                        <td class="pr-2 frazioniTitle frazioniValueR">Media {{configEvento.unitaMedia}}</td>
                        <td class="frazioniValue ">{{currentItem.media }} </td>
                    </tr>
                    <tr v-if="isOCR()">
                        <td class="pr-2 frazioniTitle frazioniValueR">Bracciali</td>
                        <td class="primaryColor"><strong>{{currentItem.col_bands }}</strong></td>
                    </tr>
                    <tr>
                        <td class="  pa-1" colspan=2>
                            <strong>Dettaglio PASSAGGI</strong>
                        </td>
                    </tr>
                    <tr v-if="currentItem.batteria != undefined && currentItem.batteria != '' && currentItem.batteria != '-'">
                        <td width="10%" class="pr-2 frazioniTitle frazioniValueR">Batteria</td>
                        <td width="90%" class="frazioniTitle">{{currentItem.batteria }}</td>
                    </tr>
                    <tr>
                        <td width="10%" class="pr-2 frazioniTitle frazioniValueR">Orario partenza</td>
                        <td width="90%" class="primaryColor">{{currentItem.guntime }}</td>
                    </tr>
                </table>
                <table v-if="!isMultilap() && currentItem != undefined" style="width: 100%" class="mb-3">
                    <tr>
                        <td width="10%" class=""></td>
                        <td width="10%" class="frazioniTitle">Fraz</td>
                        <td width="10%" class="frazioniTitle">Tempo</td>
                    </tr>
                    <tr  v-for="n in listaIntermedi " :key="'titoloDettaglio_'+n">
                        <td width="10%" class="frazioniTitle frazioniValueR pr-2">{{configEvento['label'+n]}}</td>
                        <td width="10%" class="frazioniValue ">{{currentItem['fraz'+n]}} </td>
                        <td width="10%" class="frazioniValue ">{{currentItem['tempo'+n]}}</td>
                    </tr>
                </table>
                <table v-if="isMultilap() && currentItem != undefined" style="width: 100%" class="mb-3">
                    <tr>
                        <td width="10%" class=""></td>
                        <td width="10%" class="frazioniTitle">Fraz</td>
                        <td width="10%" class="frazioniTitle">Tempo</td>
                        <td v-if="isAdmin()" width="10%" class="frazioniTitle">Orario</td>
                    </tr>
                    <tr v-for="item in currentRilevamenti " :key="'titoloDettaglio'+item.lap">
                        <td width="10%" class="frazioniTitle">{{item.lap}}</td>
                        <td width="10%" class="frazioniValue  ">{{riduci(item.fraz) }}</td>
                        <td width="10%" class="frazioniValue  ">{{ riduci(item.time)}}</td>
                        <td v-if="isAdmin()" width="10%" class="frazioniValue  ">{{ riduci(item.clock)}}</td>
                    </tr>
                </table>
                <table v-if="showGap && currentItem != undefined && currentItem.distacco1 !== '' " style="width: 100%" class="mb-3">
                    <tr v-if="showGap && currentItem.distacco1 !== ''">
                        <td class="  pa-1" colspan="2">
                            <strong>DISTACCHI</strong>
                        </td>
                    </tr>
                    <tr v-if="showGap && currentItem.distacco1 !== ''">
                        <td width="50%" class="frazioniTitle frazioniValueR pr-2">Dal primo</td>
                        <td width="50%" class="frazioniValue ">{{currentItem.distacco1 }}</td>
                    </tr>
                    <tr v-if="showGap && currentItem.distacco2 !== ''">
                        <td width="50%" class="frazioniTitle frazioniValueR pr-2">Dal precendente</td>
                        <td width="50%" class="frazioniValue">{{currentItem.distacco2 }}</td>
                    </tr>
                </table>
                <v-layout align-center row justify-center  style="height:100%">
                    <v-btn round outline small class="black  black--text" @click="dettaglio=false">Chiudi</v-btn>
                </v-layout>
            </v-layout>
        </v-dialog>
    
        <v-toolbar app color="black" dark >
            <v-toolbar-title data-cy="titleBtn">
                <img class="menuLogo ml-0 mt-2" src="../assets/images/Logo.png" style="height: 45px" @click="gotoHome()" />
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <span v-if="isLocale && isDesktopMode()" class="mr-3">
                <v-icon @click="gotoAdmin()">table_chart</v-icon>
            </span>
            <span  class="mr-3">
                <v-icon @click="gotoSL()">people</v-icon>
            </span>
            <span class="mr-3">
                <v-icon :class="getClasseFiltro()" @click="filtroDialog =true">filter_list</v-icon>
            </span>
            <span class="mr-3">
                <v-icon :class="filterToggle ? 'red--text': ''" @click="toggleSearch()">search</v-icon>
            </span>
            <v-icon v-if="!starred" @click="showStarred()">star</v-icon>
            <v-icon v-else color="yellow" @click="showStarred()">star</v-icon>
        </v-toolbar>
        <v-progress-linear v-if="showProgressBar" background-color="black" color="#006064" class="mt-0 p-0 v-toolbar--fixed" v-model="value" :buffer-value="bufferValue"></v-progress-linear>
        
        <v-layout align-start row wrap justify-center class="pa-0 black--text grey lighten-4 ">
            <v-flex flex xs10 sm10 md10 lg10 class="primaryColor white--text title mt-0 pa-2">
                <small><strong>{{ raceTitle }}</strong></small>
            </v-flex>
            <v-flex flex xs2 sm2 md2 lg2 class="primaryColor white--text title mt-0 pa-2">
                <span>{{ itemsF.length }}  </span> 
            </v-flex>

            <v-layout v-if="!isMultilap() && this.configEvento.numSplit > 1" align-center row wrap justify-center class="grey lighten-2 black--text pa-1 ">
                <table width=100%>
                    <tr>
                        <td align="left" width="15%" @click="changeSplit('-')"><v-icon color="black">arrow_left</v-icon>
                        </td>
                        <td align="center">
                            <span class="mt-0"><v-select @change="changeSegment" class="text--white pa-0"
                                    hint="Passaggio/Segmento" :items="segments" v-model="segment" single-line  
                                    persistent-hint></v-select>
                            </span>
                        </td>
                        <td align="right" width="15%" @click="changeSplit('+')"><v-icon color="black">arrow_right</v-icon>
                        </td>
                    </tr>
                </table>
            </v-layout>


            <v-flex flex xs12 sm12 md12 lg12 class="black--text title mt-0">
                <v-data-table :items="itemsF" hide-actions hide-headers class="scroll-y mb-5"  style="height: 1000px">
                    <template slot="items" slot-scope="props" >
                        <tr style="height:0px">
                        </tr>
                        <tr v-if="props.item.raggr == true" class="white display-2">
                            <td colspan="11"></td>
                        </tr>
                        <tr v-if="segment == 'LIVE' &&  props.item.raggr == true" class="backColor white--text">
                            <td colspan="11" class="pa-1" align="center">
                                <strong>{{  getUltimoPassaggio(props.item) }}</strong>
                            </td>
                        </tr>
                        <tr v-if="segment != 'LIVE' && props.index == 0" class="backColor white--text">
                            <td colspan="11" class="pa-1" align="center">
                                <strong>{{  segment }}</strong><span style="float:right">n. {{ itemsF.length }}</span>
                            </td>
                        </tr>

                        <tr v-if="( props.item.raggr == true || props.index == 0) && isDesktopMode()" class="grey black--text">
                            <td align="center">Pos</td>
                            <td v-if="showAtleta"  align="center">Atleta</td>
                            <td v-if="showPettorale" align="center">Pett</td>
                            <td v-if="showCategoria" align="center">Cat</td>
                            <td v-if="showPosCategoria" align="center">P.Cat.</td>
                            <td v-if="showSquadra" align="center">Team</td>
                            <td v-if="isMultilap()" align="center">Laps</td>
                            <td v-if="showMetri" align="center">Metri</td>
                            <td v-if="showMetri" align="center">Residuo</td>
                            <td v-if="!isUltra()" align="center">Tempo</td>
                            <td v-if="!isUltra() && showGap" align="center">Gap Prec</td>
                            <td v-if="!isUltra() && showGap" align="center">Gap Primo</td>
                            <td v-if="showBatteria" align="center">Batt</td>
                            <td align="center">Pref</td>
                        </tr>
                        <tr v-if="isDesktopMode()" style="height:20px"
                            :class="props.index % 2 == 0 ? 'grey lighten-3' : ''">
                            
                            <td v-if="getStatoAtleta(props.item.stato_atleta) == undefined" @click="showDetail(props.item)" width="5%" align="center"
                                style="padding: 0px 0px !important;">
                                <strong v-if="configEvento.filtroSesso == undefined">{{ getStato(props.item.posAss) }}</strong>
                                <strong v-else>{{ getStato(props.item.posMF) }}</strong>
                            </td>
                            <td v-else @click="showDetail(props.item)" width="5%" align="center"  style="padding: 0px 0px !important;">
                                <span :class="'ml-2 pr-1 pl-1  '+ getColorStatoAtleta(props.item.stato_atleta)">{{ getStatoAtleta(props.item.stato_atleta) }}</span>
                            </td>

                            <td v-if="showAtleta" @click="showDetail(props.item)" nowrap style="padding: 0px 10px !important;">
                                <country-flag v-if="showNazione" :country="props.item.nazione" size="small" /> {{
                                    props.item.cognome }} {{ props.item.nome }} 
                            </td>
                            <td v-if="showPettorale" @click="showDetail(props.item)" width="5%" align="center">
                                {{ props.item.pett}}
                            </td>
                            <td v-if="showCategoria" @click="showDetail(props.item)" width="5%" align="center">
                                {{ props.item.categoria }}
                            </td>
                            <td  v-if="showPosCategoria" @click="showDetail(props.item)" width="5%" align="center">
                                {{ getStato(props.item.posCat) }}
                            </td>
                            <td v-if="showSquadra"  @click="showDetail(props.item)" align="left" nowrap>
                                {{ props.item.squadra }}
                            </td>
                           

                            <td v-if="showGiri" @click="showDetail(props.item)" :class=" getColor('colorGiri', getUltimoPassaggio(props.item)  ) + ' text-xs-center'">
                                <strong>{{ getUltimoPassaggio(props.item) }}</strong>
                            </td>
                            <td v-if="showMetri" @click="showDetail(props.item)" :class=" getColor('colorMetri' ) + ' text-xs-center'">
                                <strong>{{ getFieldValue(props.item, {fieldType: 'distanza'}) }}</strong>
                            </td>
                            <td v-if="showMetri" @click="showDetail(props.item)" class="text-xs-center">
                                <strong>{{ (props.item.distanza) }}</strong>
                            </td>
                            <td v-if="isMultilap()" align="center" @click="showDetail(props.item)">
                                <strong>{{ getUltimoTempo(props.item) }}</strong>
                            </td>
                            <td v-else align="center" @click="showDetail(props.item)">
                                <strong>{{ formatTime(getTempoSegmento(props.item), 'Running') }}</strong>
                            </td>



                            <td v-if="!isUltra() && showGap" width="5%" align="center" @click="showDetail(props.item)" style="padding: 0px 10px !important;">
                                <small v-if="props.item.posAss > 1">
                                    <i class="red--text">{{ getValoreCampoSplit(props.item, 'distacco2', props.item.splitName) }}</i> 
                                </small>
                            </td>
                            <td v-if="!isUltra() && showGap" width="5%" align="center" @click="showDetail(props.item)" no-wrap style="padding: 0px 10px !important;">
                                <span v-if="props.item.posAss == 1">
                                    
                                </span>
                                <small v-else>
                                    <i class="red--text">{{ getValoreCampoSplit(props.item, 'distacco1', props.item.splitName) }}</i>
                                </small>
                            </td>
                             <td v-if="showBatteria"  @click="showDetail(props.item)" class="text-xs-center">
                                <strong>{{ props.item.batteria }}</strong>
                            </td>
                            <td align="center" width="10px" @click="starToggle(props.item)"
                                style="padding: 0px 0px !important;">
                                <v-icon small class="ml-1" v-if="props.item.starred"
                                    color="orange">star</v-icon>
                                <v-icon small class="ml-1" v-else>star_outline</v-icon>
                            </td>

                            
                        </tr>
                        <tr v-else style="height:30px" :class="props.index % 2 == 0 ? 'grey lighten-3' : ''">
                          
                            <td  v-if="categoriaSelected === 'TUTTE' && getStatoAtleta(props.item.stato_atleta) == undefined" @click="showDetail(props.item)" width="2%" align="center"
                                style="padding: 0px 0px !important;">
                                <strong v-if="configEvento.filtroSesso == undefined">{{ getStato(props.item.posAss) }}.</strong>
                                <strong v-else>{{ getStato(props.item.posMF) }}.</strong>
                            </td>
                            <td  v-else-if="categoriaSelected !== 'TUTTE' && getStatoAtleta(props.item.stato_atleta) == undefined" @click="showDetail(props.item)" width="2%" align="center"
                                style="padding: 0px 0px !important;">
                                <strong>{{ getStato(props.item.posCat) }}.</strong>
                            </td>
                            <td v-else @click="showDetail(props.item)" width="5%" align="center"  style="padding: 0px 0px !important;">
                                <span :class="'ml-2 pr-1 pl-1 '+ getColorStatoAtleta(props.item.stato_atleta)">{{ getStatoAtleta(props.item.stato_atleta) }}</span>
                            </td>
                            <td v-if="showNazione" width="5%" style="padding: 0px 5px !important;" @click="showDetail(props.item)" > 
                                <country-flag  :country="props.item.nazione" size="small" /></td>
                            <td v-if="showAtleta" @click="showDetail(props.item)" width="80%" align="left"
                                style="padding: 0px 0px !important;">
                                <strong class=""> {{ props.item.cognome }}</strong> <small class="ml-1">{{ props.item.nome }}  </small>
                            </td>
                           
                            <td v-if="showGiri && isMultilap()" width="10%" align="right"  @click="showDetail(props.item)" no-wrap style="padding: 0px 10px !important;">
                                <strong>{{ getUltimoPassaggio(props.item) }}</strong>
                            </td>
                            
                            <td width="10%" align="right"  @click="showDetail(props.item)" no-wrap style="padding: 0px 10px !important;">
                                <span>
                                    <strong v-if="isUltra()">{{   getFieldValue(props.item, {fieldType: 'distanza'}) }} </strong>
                                    <strong v-else-if="isMultilap()">{{ formatTime(getUltimoTempo(props.item) )}}</strong>
                                    <strong v-else>{{ formatTime(getTempoSegmento(props.item), 'Running') }}</strong>
                                    <br v-if="showGap"> 
                                    <small v-if="showGap">
                                        <i class="red--text">{{ getValoreCampoSplit(props.item, 'distacco1', props.item.splitName) }}</i>
                                    </small>
                                </span>
                            </td>
                            <td v-if="showBatteria" width="1px" align="right" :class=" getColor('colorBatteria', (props.item.batteria)  ) + ' text-xs-center'"   @click="showDetail(props.item)" no-wrap style="padding: 0px 10px !important;">
                            </td>
                            <td align="center"  @click="starToggle(props.item)"
                                style="padding: 0px 10px !important;">
                                <v-icon small class="ml-1" v-if="props.item.starred"
                                    color="orange">star</v-icon>
                                <v-icon small class="ml-1" v-else>star_outline</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-flex>

        </v-layout>
        <v-layout v-if="!configOK " align-start row wrap justify-center class="mt-4 ">
            <v-flex flex xs12 sm12 md12 lg12 class="mb-5">
                <v-layout class="display-1 justify-center">LIVE NON CONFIGURATO</v-layout>
            </v-flex>
        </v-layout>
        <v-footer v-if="filterToggle" fixed class="p-0 grey darken-2" style="height: 30px;">
            <v-layout align-start row wrap justify-center :class=" color + '  darken-2 p-0 m-0 '" style="width:100%; ">
                <v-flex flex xs12 sm12 md12 lg12 class="white pa-2">
                    <v-text-field class="white red--text pa-0" style="width:100%;" v-model="searchText" label="Cerca cognome, team o pettorale" outline clearable append-icon="search" @input="changedSearch"></v-text-field>
                </v-flex>
            </v-layout>
        </v-footer>
    </div>
    </template>
    
    <script>
    import helper from '../helper';
    import dayjs from 'dayjs';

    
    export default {
        components: {
        },
        name: 'LiveAttivoSeq',
    
        data() {
            return {
                addClockDialog: false,
                baseColor: 'white:black',
                bufferValue: 100,
                categoriaSelected: 'TUTTE',
                categorieDaPremiare: "",
                chipMap: {},
                clockBatterie: {},
                clockBatterieFinish: {},
                clockToAdd: "",
                color: 'red',
                compatta: true,
                configEvento: {},
                configOK: false,
                currentIndex: 1,
                currentItem: null,
                currentRilevamenti: {},
                dettaglio: false,
                dettaglioBands: false,
                dettaglioPremiazioniDialog: false,
                direction: true,
                divisioneSelected: 'TUTTE',
                divisioniOriginali: {},
                elencoIscritti: [],
                escludiAssolutiDaCat: true,
                filtraPosCat: 0,
                filtroDialog: false,
                filterPreferiti: false,
                filterToggle: false,
                gunTimeNew: '',
                indexTo: -1,
                interval: 0,
                isLocale: false,
                items: [],
                itemsF: [],
                listaBatterieOriginali: [],
                listaCategorie: [],
                listaCategorieOriginali: [],
                listaDivisioni: [],
                listaIntermedi: [],
                listaNazioni: [],
                listaPreferiti: {},
                listaSesso: ['TUTTI', 'MASCHILE', 'FEMMINILE'],
                loaded: false,
                local: undefined,
                mappaDivisioni: {},
                mappaFiles: {},
                mappaIntermedi: {},
                mappaSplit: {},
                mappaSplitLabel : {},
                mostraNazione: false,
                multiDivisione: false,
                myInterval: null,
                nazioneSelected: 'TUTTE',
                numFrac: 1,
                numPremiazioniAssoluteF: 3,
                numPremiazioniAssoluteM: 3,
                numPremiazioniCategoria: 3,
                numRilevamentiStep: 0,
                onlyWarning: false,
                orderByField: null,
                partecipantiOriginali: 0,
                pause: false,
                raceDate: '',
                raceDateNew: '',
                raceTime: '00:00:00',
                raceTitle: '',
                refreshData: 60000,
                refreshDataNew: 60000,
                refreshPage: 300000,
                rilevamentoSelected: undefined,
                rilevamentoSelectedTitle: undefined,
                rilevamentoSelectedType: undefined,
                searchText: '',
                settings: false,
                settingsTab: 1,
                sessoSelected: 'TUTTI',
                showBatteria: false,
                showButtons: true,
                showDivisione: false,
                showDownload: false,
                showGap: false,
                showHeaders: true,
                showMedia: false,
                showPosCategoria: false,
                showPrint: false,
                showProgressBar: true,
                showStato: false,
                showTimer: true,
                sottoClassificheOriginali: {},
                sport: '',
                stats: false,
                tagFile: null,
                value: 0,
                warningDelta: 2,
                warningLaps: 5,

                segments: [],
                segment: 'LIVE',

                color: "#0D3D58",
                starred: false,
                mapStars: {},

                jsonVersion: -1,

                touchstartX: -1,
                touchstartY: -1,
                touchendX: -1,
                touchendY: -1,

                versionC: -1,
                versionP: -1,

                statoOrdine: { "-": 0, "DSQ": 1, "DNF": 2, "DNS": 4, "TBD": 3 },

                isPageVisible: true,

                showGiri: false,
                showMetri: false

            };
        },
    
        beforeCreate() {},

        beforeDestroy() {
            clearInterval(this.myInterval);
            clearInterval(this.myIntervalBar);
        },


    
        created() {
            window.addEventListener('keydown', this.doCommand);
            document.addEventListener('visibilitychange', this.handleVisibilityChange);
            //window.addEventListener('touchstart', this.handleGesture);
            //window.addEventListener('touchend', this.handleGesture);

        },
        destroyed() {
            window.removeEventListener('keydown', this.doCommand);
            // window.removeEventListener('touchstart', this.handleGesture);
            //window.removeEventListener('touchend', this.handleGesture);
        },
    
        beforeDestroy() {
            clearInterval(this.myInterval);
            clearInterval(this.myIntervalBar);
            document.removeEventListener('visibilitychange', this.handleVisibilityChange);

        },
    
        mounted() {
            //console.log(this.$route.params.sport);
            console.log(this.$route.params.raceID);

            this.raceID = this.$route.params.raceID;
            this.paramID = this.$route.params.id;


            this.mapStars = helper.ls.get('ICRONSTARS' + this.raceID+"_"+this.paramID);
            if (this.mapStars == undefined) {
                this.mapStars = {};
                helper.ls.set('ICRONSTARS' + this.raceID+"_"+this.paramID, this.mapStars);
            }


          

            this.resetAll();
            this.loadEvento();
        },
    
        methods: {

             isAdmin() {
                if ( this.configEvento.admin !== undefined && this.configEvento.admin == 'admin123' ) return true;
                return this.configEvento.admin !== undefined && this.configEvento.admin === ( (this.raceID + this.paramID).split("").reverse().join("")) ;
            },

            handleVisibilityChange() {
                this.isPageVisible = !document.hidden;
            },
            

            resetAll(){

                this.raceID = this.$route.params.raceID;
                this.paramID = this.$route.params.id;
                this.local = this.$route.params.local;
               

        
                var pref = helper.ls.get('PREFERITI_' + this.$route.params.raceID);
                console.log('Preferiti:' + JSON.stringify(pref));
                if (pref == undefined) {
                    helper.ls.set('PREFERITI_' + this.$route.params.raceID, {});
                    this.listaPreferiti = {};
                } else {
                    this.listaPreferiti = pref;
                }
        
                this.isLocale = true;
                if ( window.location.hostname.indexOf("icron.it") != -1 ) {
                    this.isLocale = false;
                }


                clearInterval(this.myInterval);
                clearInterval(this.myIntervalBar);

                this.addClockDialog = false;
                this.baseColor = 'white:black';
                this.bufferValue = 100;
                this.categoriaSelected = 'TUTTE';
                this.categorieDaPremiare = "";
                this.chipMap = {};
                this.clockBatterie = {};
                this.clockBatterieFinish = {};
                this.clockToAdd = "";
                this.color = 'red';
                this.compatta = true;
                this.configEvento = {};
                this.configOK = false;
                this.currentIndex = 1;
                this.currentItem = null;
                this.currentRilevamenti = {};
                this.dettaglio = false;
                this.dettaglioBands = false;
                this.dettaglioPremiazioniDialog = false;
                this.direction = true;
                this.divisioneSelected = 'TUTTE';
                this.divisioniOriginali = {};
                this.elencoIscritti = [];
                this.escludiAssolutiDaCat = true;
                this.filtraPosCat = 0;
                this.filtroDialog = false;
                this.filterPreferiti = false;
                this.filterToggle = false;
                this.gunTimeNew = '';
                this.indexTo = -1;
                this.interval = 0;
                //this.isLocale = false;
                this.items = [];
                this.itemsF = [];
                this.listaBatterieOriginali = [];
                this.listaCategorie = [];
                this.listaCategorieOriginali = [];
                this.listaDivisioni = [];
                this.listaIntermedi = [];
                this.listaNazioni = [];
                this.listaPreferiti = {};
                this.listaSesso = ['TUTTI', 'MASCHILE', 'FEMMINILE'];
                this.loaded = false;
                // this.local = undefined;
                this.mappaDivisioni = {};
                this.mappaFiles = {};
                this.mappaIntermedi = {};
                this.mappaSplit = {};
                this.mappaSplitLabel = {};
                this.mostraNazione = false;
                this.multiDivisione = false;
                this.myInterval = null;
                this.nazioneSelected = 'TUTTE';
                this.numFrac = 1;
                this.numPremiazioniAssoluteF = 3;
                this.numPremiazioniAssoluteM = 3;
                this.numPremiazioniCategoria = 3;
                this.numRilevamentiStep = 0;
                this.onlyWarning = false;
                this.orderByField = null;
                this.partecipantiOriginali = 0;
                this.pause = false;
                this.raceDate = '';
                this.raceDateNew = '';
                this.raceTime = '00:00:00';
                this.raceTitle = '';
                this.refreshData = 60000;
                this.refreshDataNew = 60000;
                this.refreshPage = 300000;
                this.rilevamentoSelected = undefined;
                this.rilevamentoSelectedTitle = undefined;
                this.rilevamentoSelectedType = undefined;
                this.searchText = '';
                this.settings = false;
                this.settingsTab = 1;
                this.sessoSelected = 'TUTTI';
                this.showBatteria = false;
                this.showButtons = true;
                this.showDivisione = false;
                this.showDownload = false;
                this.showGap = false;
                this.showHeaders = true;
                this.showMedia = false;
                this.showPosCategoria = false;
                this.showPrint = false;
                this.showProgressBar = true;
                this.showStato = false;
                this.showTimer = true;
                this.sottoClassificheOriginali = {};
                this.sport = '';
                this.stats = false;
                this.tagFile = null;
                this.value = 0;
                this.warningDelta = 2;
                this.warningLaps = 5;

                this.versionC= -1;
                this.versionP= -1;

            },
    
            loadEvento() {
                this.listaIntermedi = [];
                this.elencoIscritti = [];
    
                console.log(this.raceID);
                //const _url = this.getDataURL() + "getFile?idGara=" + this.raceID + "&fileName=remoteLiveConfiguration" + this.raceID + "_" + this.paramID + ".txt";;
                const _url = this.getDataURL() + "getDatiEvento?idGara=" + this.raceID + "&id="+ this.paramID;
                //  if (this.local) _url = "/local/"+ this.raceID+"/localLiveConfiguration" + this.raceID + "_" + this.paramID + ".csv";
                console.log(_url);
                this.getCall(_url).then((response) => {
                    if (response !==  undefined) {
                        this.versionC = response.versionC
                        this.versionP = response.versionP
                        console.log("Version C:" + this.versionC);
                        console.log("Version P:" + this.versionP);
                        this.configRace(response);
                    } else {
                        //alert("Evento non configurato.");
                        this.configEvento = {}
    
                        if (this.local !== undefined) {
                            const toks = this.local.split(",");
                            toks.forEach(tok => {
                                if (tok.indexOf("=") !== -1) {
                                    const keyval = tok.split("=");
                                    this.configEvento[keyval[0]] = this.normalize(keyval[1]);
                                }
                            })
                        }
                    }
    
                }); //fine
            },
    
            configRace(response) {
                this.configEvento = this.properties2Object(response.config);
                this.configOK = true;

                if (this.isMultilap()) {
                    this.showGiri = true
                    if (this.isUltra())
                        this.showMetri = true
                }
    
                if (this.local !== undefined) {
                    const toks = this.local.split(",");
                    toks.forEach(tok => {
                        if (tok.indexOf("=") !== -1) {
                            const keyval = tok.split("=");
                            this.configEvento[keyval[0]] = this.normalize(keyval[1]);
                        }
                    })
                }
    
                if (this.configEvento.liveTemplate !== undefined ) {
                    let  _url = "/"+this.configEvento.liveTemplate+"/" + this.raceID + "/" + this.paramID;
                    if (this.local !== undefined) _url += "/"+this.local;
                    
                    this.$router.push(_url);
                    return;
                }
                
                this.raceDate = this.configEvento.raceDate;
                this.raceDateNew = this.configEvento.raceDate;
                if (this.configEvento.gunTime == undefined || this.configEvento.gunTime == '') {
                    alert("Attenzione, impostare il guntime generale")
                    this.loaded= true;
                    return
                }
                if (this.configEvento.raceDate == undefined || this.configEvento.raceDate == '') {
                    alert("Attenzione, impostare la data evento")
                    this.loaded= true;
                    return
                }
                if (this.configEvento.gunTime.indexOf(".") == -1) this.configEvento.gunTime += ".000";
                this.gunTimeNew = this.configEvento.gunTime;
                this.configEvento.gunTime = this.raceDate+"-"+this.configEvento.gunTime;
    
                for (let i = 1; i < 100; i++) {
                    //alert(this.configEvento['split' + i]) ;
                    if (this.configEvento['split' + i] !== undefined) {
                        this.configEvento.numSplit = i;
                    } else {
                        break;
                    }
                }
    
                //alert(this.configEvento.numSplit);
    
                //this.configEvento.numSplit = parseInt(this.configEvento.numSplit);
                if (this.configEvento.timeFormat == undefined) this.configEvento.timeFormat = 'HH:mm:ss';
                if (this.configEvento.gapFormat == undefined) this.configEvento.gapFormat = 'HH:mm:ss';
    
                this.color = this.configEvento.color !== undefined ? this.configEvento.color : 'red';
                this.baseColor = this.configEvento.baseColor !== undefined ? this.configEvento.baseColor : this.baseColor;
                this.showGap = (this.configEvento.showGap !== undefined && this.configEvento.showGap == 'true') ? true : false;
                this.showMedia = (this.configEvento.showMedia !== undefined && this.configEvento.showMedia == 'true') ? true : false;
                this.numFrac = (this.configEvento.numFrac !== undefined) ? parseInt(this.configEvento.numFrac) : 0;
    
                this.showDivisione = (this.configEvento.showDivisione !== undefined && this.configEvento.showDivisione == 'true') ? true : false;
                this.showPosAssoluta = (this.configEvento.showPosAssoluta !== undefined && this.configEvento.showPosAssoluta == 'true') ? true : false;
                this.showPosDivisione = (this.configEvento.showPosDivisione !== undefined && this.configEvento.showPosDivisione == 'true') ? true : false;
                this.showPosMF = (this.configEvento.showPosMF !== undefined && this.configEvento.showPosMF == 'true') ? true : false;
                this.showSesso = (this.configEvento.showSesso !== undefined && this.configEvento.showSesso == 'true') ? true : false;
                this.showPettorale = (this.configEvento.showPettorale !== undefined && this.configEvento.showPettorale == 'true') ? true : false;
                this.showNazione = (this.configEvento.showNazione !== undefined && this.configEvento.showNazione == 'true') ? true : false;
                
                this.showAtleta = (this.configEvento.showAtleta !== undefined && this.configEvento.showAtleta == 'false') ? false : true;
                this.showCategoria = (this.configEvento.showCategoria !== undefined && this.configEvento.showCategoria == 'false') ? false : true;
                this.showPosCategoria = (this.configEvento.showPosCategoria !== undefined && this.configEvento.showPosCategoria == 'false') ? false : true;
                this.showSquadra = (this.configEvento.showSquadra !== undefined && this.configEvento.showSquadra == 'false') ? false : true;

                this.showGiri = (this.configEvento.showGiri !== undefined && this.configEvento.showGiri == 'true') ? true : this.showGiri;
                this.showMetri = (this.configEvento.showMetri !== undefined && this.configEvento.showMetri == 'true') ? true : this.showMetri;
                
                this.showOrario = (this.configEvento.showOrario !== undefined && this.configEvento.showOrario == 'true') ? true : false;
                this.showTempo = (this.configEvento.showTempo !== undefined && this.configEvento.showTempo == 'false') ? false : true;
                this.showBatteria = (this.configEvento.showBatteria !== undefined && this.configEvento.showBatteria == 'true') ? true : false;
                this.showStato = (this.configEvento.showStato !== undefined && this.configEvento.showStato == 'true') ? true : false;

                this.showQualif = (this.configEvento.showQualif !== undefined && this.configEvento.showQualif == 'true') ? true : false;
                this.numQualif = (this.configEvento.numQualif !== undefined) ? parseInt(this.configEvento.numQualif)  : 16;
                this.filtroQualif = (this.configEvento.filtroQualif !== undefined && this.configEvento.filtroQualif == 'false') ? true : false;
    
    
    
                this.showButtons = (this.configEvento.showButtons !== undefined && this.configEvento.showButtons == 'false') ? false : true;
                this.showPrint = (this.configEvento.showPrint !== undefined && this.configEvento.showPrint == 'true') ? true : false;
                this.showDownload = (this.configEvento.showDownload !== undefined && this.configEvento.showDownload == 'true') ? true : false;
    
                this.showTimer = (this.configEvento.showTimer !== undefined && this.configEvento.showTimer == 'true') ? true : false;
                this.showProgressBar = (this.configEvento.showProgressBar !== undefined && this.configEvento.showProgressBar == 'false') ? false : true;
                this.showHeaders = (this.configEvento.showHeaders !== undefined && this.configEvento.showHeaders == 'false') ? false : true;
    
    
                this.refreshPage = (this.configEvento.refreshPage !== undefined) ? parseInt(this.configEvento.refreshPage) * 1000 : 300000;
                this.refreshData = (this.configEvento.refreshData !== undefined) ? parseInt(this.configEvento.refreshData) * 1000 : 60000;

                if (this.local == undefined && !this.isLocale){
                    this.refreshData = 30000; 
                    console.log("SONO SU INTERNET! Forzo refresh a 60 secondi ")
                }
    
                this.orderByField = (this.configEvento.orderByField !== undefined) ? this.configEvento.orderByField : null
                this.direction = (this.configEvento.orderByDirection !== undefined) ? (this.configEvento.orderByDirection == 'ASC' ? true : false) : false
                this.filtraPosCat = (this.configEvento.filtraPosCat !== undefined ) ? parseInt(this.configEvento.filtraPosCat) : 0
    
                this.indexTo = (this.configEvento.indexTo !== undefined) ? parseInt(this.configEvento.indexTo) : -1
    
                this.warningDelta = (this.configEvento.warningDelta !== undefined) ? parseFloat(this.configEvento.warningDelta) : 2
                this.warningLaps = (this.configEvento.warningLaps !== undefined) ? parseFloat(this.configEvento.warningLaps) : 5
    
                if (this.configEvento.metriPerGiro !== undefined) this.configEvento.metriPerGiro = this.configEvento.metriPerGiro.replace(",",".");
    
                if (this.isOCR()) this.configEvento.criterioClass = "col_bands,tempo"
    
                this.fields = [];
                if (this.configEvento.fields !== undefined) {
                    this.fields = this.configEvento.fields.split(",");
                }
    
                if (this.getBatterie().length > 0) {
                    console.log("BATTERIE")
                    let batterie = this.getBatterie();
                    batterie.forEach(batt => {
                        console.log("Batteria " + JSON.stringify(batt) )
                        this.clockBatterie[batt['name']] = this.raceDate+"-"+ batt['guntime'];
                        this.clockBatterieFinish[batt['name']] = this.raceDate+"-"+ batt['finishtime'];
                    })
                } else {
                    console.log("Nessuna batteria")
                }
    
                this.raceTitle = this.configEvento['raceTitle'];

                

                this.segments.push("LIVE")

                for (let index = 1; index <= (this.configEvento.numSplit); index++) {
                    this.listaIntermedi.push(index);
                    this.mappaIntermedi[index] = 0;
    
                    const split = this.configEvento['split' + index];
                    if (split !== undefined) {
    
                        const _split = split.replaceAll(" ", ",").replaceAll(";", ",").replaceAll("\t", ",").replaceAll(",,",",").replaceAll(",,",",").replaceAll(",,",",").replaceAll(",,",",").replaceAll(",,",",");
                        const toks = _split.split(",");
                        this.configEvento['titolo' + index] = toks[0];

                        this.mappaSplit[toks[0]] = index;

                        
                        
                        
                        toks.forEach(tok => {
                            if (tok.indexOf("=") !== -1) {
                                const keyval = tok.split("=");
                                this.configEvento[keyval[0] + index] = this.normalize(keyval[1]);
                            }
                        })

                        let _label = this.configEvento['label'+index] ;
                        if (_label == undefined) {
                            _label = toks[0];
                            this.configEvento['label'+index] = toks[0];
                        } 

                        this.segments.push(_label)
                        this.mappaSplitLabel[ _label] = toks[0]
                    }
                    console.log(this.configEvento);
    
                }

                
    
    
                let res = (this.configEvento.raceType !== undefined && this.configEvento.raceType.indexOf('ocr') !== -1)
                
                console.log(">>>>>>>>>>>>>  IS OCR:" + res)

                let categorieOriginali = {};
                let batterieOriginali = {};
    
                //const _url = this.getDataURL() + "getFileFromCache?idGara=" + this.raceID + "&fileName=remoteLiveParticipants" + this.raceID + "_" + this.paramID + ".csv";
                //if (this.local) _url = "/local/"+ this.raceID+ "/localLiveParticipants" + this.raceID + "_" + this.paramID + ".csv";
                //this.getRemoteService(_url).then((response) => {
                    this.elencoIscritti = this.csvJSON(response.participants).filter(elem => {

                        this.divisioniOriginali[elem.divisione] = this.divisioniOriginali[elem.divisione] == null ? 1 : this.divisioniOriginali[elem.divisione]+1 ;
                        
                        categorieOriginali[elem.categoria] = categorieOriginali[elem.categoria] == null ? 1 : categorieOriginali[elem.categoria]+1 ;
                        this.listaCategorieOriginali = Object.keys(categorieOriginali);
                        this.listaCategorieOriginali.sort();

                        if (elem['partenza onda'] != undefined && elem['partenza onda'] != '' && elem['partenza onda'] != '-')
                        batterieOriginali[elem['partenza onda']] = batterieOriginali[elem['partenza onda']] == null ? 1 : batterieOriginali[elem['partenza onda']]+1 ;
                        this.listaBatterieOriginali = Object.keys(batterieOriginali);
                        this.listaBatterieOriginali.sort();


                        if (elem.classif !== '-'){
                            elem.classif.split(",").forEach( el => {
                                this.sottoClassificheOriginali[el.trim()] = this.sottoClassificheOriginali[el.trim()] == null ? 1 : this.sottoClassificheOriginali[el.trim()]+1 ;
                            })
                        }

                        this.partecipantiOriginali++;


                        let res = true;
                        if (this.configEvento.filtroCategorie) {
                            const found = this.configEvento.filtroCategorie.split(",").find(element => element === elem.categoria);
                            res = found !== undefined;
                        }
                        if (res) {
                            if (this.configEvento.filtroDivisioni) {
                                const found = this.configEvento.filtroDivisioni.split(",").find(element => element === elem.divisione);
                                res = found !== undefined;
                            }
                        }
                        if (res) {
                            if (this.configEvento.filtroBatterie) {
                                const found = this.configEvento.filtroBatterie.split(",").find(element => element === elem['partenza onda']);
                                res = found !== undefined;
                            }
                        }
    
                        if (res) {
                            if (this.configEvento.filtroSottoclassifica) {
                                console.log(" filtroSottoclassifica ATTIVO:" + this.configEvento.filtroSottoclassifica)
                                const ff = this.configEvento.filtroSottoclassifica.split(",").filter( fsott => {
                                    return elem.classif.split(",").find(fsottPartecipante => fsottPartecipante === fsott);
                                })
                                res = ff.length > 0;
                            }
                        }
    
                        if (res) {
                            if (this.configEvento.filtroSesso) {
                                if (this.configEvento.filtroSesso == undefined || this.configEvento.filtroSesso == '') return true;
                                //console.log(" filtroSesso ATTIVO:" + this.configEvento.filtroSesso)
                                const found = this.configEvento.filtroSesso.split(",").find(element => element === elem.sesso);
                                res = found !== undefined;
                               // res = this.configEvento.filtroSesso === elem.sesso;
                            }
                        }
    
                        if (this.configEvento.filtroPettorale !== undefined) {
                            const listaPett = this.configEvento.filtroPettorale.split(",");
                            const found = listaPett.find(element => element === elem.pett);
                            res = found !== undefined;
                        }
    
                        return res
                    });
    
                    this.mappaDivisioni = {};
                    this.mappaMetriDivisioni = {};
                    this.listaDivisioni = [];
                    this.listaCategorie = [];
                    let mappaCategorie = {};
                    let mappaNazioni = {};

                    let mappaBatterie = {};


                    this.listaSplit = this.getSplits();
                    this.loaded = true;

    
                    this.listaDivisioni.push('TUTTE');
                    this.listaCategorie.push("TUTTE");
    
    
                    this.elencoIscritti.forEach(elem => {
                        if (elem.nazione && elem.nazione.length > 3) {
                            elem.nazione = elem.nazione.substring(0, 3).toLowerCase();
                        } else if (elem.nazione === undefined || elem.nazione === '') {
                            elem.nazione = 'ita';
                        }
                        elem.nazione = this.normalizeNaz(elem.nazione);
                         mappaNazioni[elem['nazione']] = elem['nazione'];
    
    
                        if (elem['partenza onda'] != undefined) {
                            elem.batteria = elem['partenza onda']
                            if (elem.batteria != undefined && elem.batteria != '-')
                                mappaBatterie[elem.batteria] = mappaBatterie[elem.batteria] == null ? 1 : mappaBatterie[elem.batteria]+1 ;
                        }
    
                        if (this.isOCR() && elem.col_bands == undefined) {
                            elem.col_bands = 0;
                        }
    
                        if (elem.pettorale !== undefined) {
                            elem.pett = elem.pettorale
                        } else if (elem.p !== undefined) {
                            elem.pett = elem.p
                        } else if (elem.dorsale !== undefined) {
                            elem.pett = elem.dorsale
                        } else if (elem.dors !== undefined) {
                            elem.pett = elem.dors
                        }
    
                        elem.rilevamenti = {};
                        for (let index = 1; index <= (this.configEvento.numSplit); index++) {
                            elem.rilevamenti[index] = [];
                        }
    
                        if (elem['chip'] != undefined) {
                            if (elem['chip'].indexOf("-") !== -1) {
                                let chips = elem['chip'].split("-");
                                chips.forEach(chip => {
                                    this.chipMap[chip] = elem;
                                })
                            } else {
                                this.chipMap[elem['chip']] = elem;
                            }
                        }
    
                        this.chipMap[elem['pett']] = elem; // aggiungo anche la possibilità di usare il pettorale come chip
    
                        if (elem.guntime == undefined || elem.guntime == '') {
                            elem.guntime = this.configEvento.gunTime;
    
                            if (this.configEvento['gunTime' + elem.divisione] !== undefined && this.configEvento['gunTime' + elem.divisione] !== '') {
                                elem.guntime = this.raceDate+"-"+this.configEvento['gunTime' + elem.divisione];
                            }
    
                            if (elem.batteria !== undefined && elem.batteria !== '' && this.clockBatterie[elem.batteria] !== undefined) {
                                elem.guntime = this.clockBatterie[elem.batteria];
                            }
                            if (elem.batteria !== undefined && elem.batteria !== '' && this.clockBatterieFinish[elem.batteria] !== undefined) {
                                elem.finishtime = this.clockBatterieFinish[elem.batteria];
                            }
                        }
    
                        elem.distanzaDivisione = this.configEvento.distanza;
                        if (this.configEvento['distanza' + elem.divisione] !== undefined && this.configEvento['distanza' + elem.divisione] !== '') {
                                elem.distanzaDivisione = this.configEvento['distanza' + elem.divisione];
                        }
    
    
                        let mdiv = this.mappaDivisioni[elem['divisione']];
                        if (mdiv === undefined && elem['divisione'] != undefined) {
                            let numLaps = -1;
                            if (this.configEvento['giriDivisione' + elem['divisione']]) {
                                numLaps = parseInt(this.configEvento['giriDivisione' + elem['divisione']]);
                            }
    
                            let metriLaps = 0;
                            let md = this.configEvento['metriDivisione' + elem['divisione']];
                            if (md !== undefined) {
                                md = md.replace(",",".");
                                metriLaps = parseFloat(md).toFixed(2);
                                console.log("METRILAPS:" + metriLaps)
                            }
    
                            this.mappaDivisioni[elem['divisione']] = {
                                id: elem['divisione'],
                                numGiri: numLaps,
                                deltaMetri: metriLaps
                            };
                            //this.listaDivisioni.push(elem['divisione']);
                            console.log("Divisione aggiunta: >>" + JSON.stringify(this.mappaDivisioni[elem['divisione']]) + "<<")
                        }
                        const _cc = elem['sesso'] + " - " + elem['categoria'];
                        mappaCategorie[_cc] = elem['categoria'];
                        //console.log("Categoria aggiunta: >>" + mappaCategorie[_cc]  + "<<")
                    })
    
                    //if (this.configEvento.filtroDivisioni === undefined) {
                    this.listaDivisioni = Object.keys(this.mappaDivisioni);
                    if (this.listaDivisioni.length > 1) {
                        this.multiDivisione = true;
                        this.listaDivisioni.unshift("TUTTE");
                    }
                    //  }
                    this.listaDivisioni.sort();

                    this.listaBatterie = Object.keys(mappaBatterie).sort();
    
                    this.listaCategorie = Object.keys(mappaCategorie);
                    if (this.listaCategorie.length > 1) {
                    }
                    //  }
                    this.listaCategorie.sort();
    
                    this.mostraNazione = Object.keys(mappaNazioni).length > 1;
                    this.listaNazioni = Object.keys(mappaNazioni);
                    this.listaNazioni.sort();
                    this.listaNazioni.unshift("TUTTE");
    
    
                    this.refresh(this);
                    this.myInterval = setInterval(this.refresh, this.refreshData, this);
                    this.myIntervalBar = setInterval(this.refreshBar, 1000, this);

               // });
            },


    
            isRealTime() {
                return (this.configEvento.raceType !== undefined && this.configEvento.raceType.indexOf('realtime') !== -1)
            },
    
            isMultilap() {
                return  this.isUltra() || (this.configEvento.raceType !== undefined && this.configEvento.raceType == 'multilap')
                //return (this.configEvento.raceType !== undefined && this.configEvento.raceType.indexOf('multilap') !== -1)
            },
    
            isOCR() {
                return (this.configEvento.raceType !== undefined && this.configEvento.raceType.indexOf('ocr') !== -1)
            },
    
            isMultiDay() {
                return (this.configEvento.multiDay !== undefined && this.configEvento.multiDay == 'true')
            },
    
    
            isUltra() {
                return (this.configEvento.raceType !== undefined && this.configEvento.raceType.indexOf('ultra') !== -1)
            },
    
            isMultiDivisione() {
                return this.listaDivisioni.length > 1;
            },
    
            refreshAll() {
                clearInterval(this.myInterval);
                clearInterval(this.myIntervalBar);
                //alert("Riavvio pagina")
                window.location.reload();
    
            },
    
            getFieldValue(item, field) {
                if (field.fieldType == 'field') {
                    //console.log(field.columnName)
                    return item[field.columnName]
                }
                if (field.fieldType == 'distanza') {
                    let delta = 0;
                    //console.log("ECCOMI");
                    if (this.mappaDivisioni[item.divisione] && this.mappaDivisioni[item.divisione].deltaMetri) {
                        delta = parseFloat(this.mappaDivisioni[item.divisione].deltaMetri)
                    }
    
                    if (item.distanza !== undefined && !isNaN(item.distanza) ) {
                        delta += parseFloat(item.distanza)
                    }
    
                    
                    const numLaps = item.rilevamenti[1].length;
                    const mpg = parseFloat(this.configEvento.metriPerGiro);
                    const value = parseFloat ((numLaps * mpg) +  delta ).toFixed(2);
                    //console.log(value);
                    return value
                }
    
                return item[field.fieldType + field.splitNum]
            },
    
            getColumnName(field) {
                return field.columnName
            },
    
            getFieldName(key) {
                if (key.indexOf(":") !== -1) {
                    return key.split(":")[0];
                }
                return key;
            },
    
            getFieldlabel(key) {
                if (key.indexOf(":") !== -1) {
                    return key.split(":")[1];
                }
                return key;
            },
    
            getColor(columnName, valore) {
                let colore = this.configEvento[columnName+valore];
                if (colore === undefined) {
                    colore = this.configEvento[columnName];
                    if (colore === undefined) {
                        colore = this.configEvento.baseColor;
                    }
                }
                if (colore !== undefined) {
                    if (colore.indexOf(":") !== -1) {
                        return colore.split(":")[0] + ' ' + colore.split(":")[1] + '--text '
                    } else {
                        return colore + ' white--text '
                    }
                }
                return 'white black--text '
            },
    
            getUltimoPassaggio(item, tailNum = 1) {



                if (this.isMultilap()) {
                    if (item && item.rilevamenti && item.rilevamenti[1]) {
                        let numLaps = item.rilevamenti[1].length;
                        if (tailNum <= numLaps) {
                            return (numLaps - tailNum + 1);
                        }
                    }
                } else {
                    for (let index = (this.configEvento.numSplit); index > 0; index--) {
                        if (item['tempo' + index] !== undefined) {
                            return this.configEvento['label' + index];
                        }
                    }
                }
                /*    for (let index = (this.configEvento.numSplit); index > 0; index--) {
                        if (this.isMultilap()) {
                            if (item && item.rilevamenti) {
                                let numLaps = item.rilevamenti[index].length;
                                if (tailNum <= numLaps) {
                                    return this.configEvento['titolo' + index] + " " + (numLaps - tailNum + 1);
                                }
                            }
                        }
    
                    }*/
                if (this.configEvento.showDNS !== undefined) return item.stato_atleta ;
                return undefined;
            },
            getUltimoTempo(item, tailNum = 1) {
                
                if (this.isMultilap()) {
                    if (item && item.rilevamenti) {
                        let numLaps = item.rilevamenti[1].length;
                        if (tailNum <= numLaps) {
                            return (item.rilevamenti[1][numLaps - tailNum]['time']);
                        }
                    }
                } else {
                    for (let index = (this.configEvento.numSplit); index > 0; index--) {
                        if (item['tempo' + index] !== undefined) {
                            return item['tempo' + index];
                        }
                    }
                }
                if (this.configEvento.showDNS ) return item.stato_atleta 
                return undefined;
            },
    
            getUltimoOrario(item, tailNum = 1) {
                if (this.isMultilap()) {
                    if (item && item.rilevamenti) {
                        let numLaps = item.rilevamenti[1].length;
                        if (tailNum <= numLaps) {
                            return this.riduci(item.rilevamenti[1][numLaps - tailNum]['clock']);
                        }
                    }
                } else {
                    for (let index = (this.configEvento.numSplit); index > 0; index--) {
                        if (item['tempo' + index] !== undefined) {
                            return this.riduci(item.rilevamenti[index][numLaps - tailNum]['clock']);
                        }
                    }
                }
                return undefined;
            },
    
            getFrazione (item, indexRil = 0, riduci = true) {
                if (this.isMultilap()) {
                    if (item && item.rilevamenti) {
                        let numLaps = item.rilevamenti[1].length;
                        if (indexRil < numLaps) {
                            if (riduci)
                                return this.riduci(item.rilevamenti[1][indexRil]['fraz']);
                            else 
                                return (item.rilevamenti[1][indexRil]['fraz']);
                        }
                    }
                }
                return undefined;
            },
    
             getTempoFrazione (item, index = 0, riduci = true) {
                if (this.isMultilap()) {
                    if (item && item.rilevamenti) {
                        let numLaps = item.rilevamenti[1].length;
                        if (index < numLaps) {
                            if (riduci)
                                return this.riduci(item.rilevamenti[1][index]['time']);
                            else 
                                return (item.rilevamenti[1][index]['time']);
                        }
                    }
                }
                return undefined;
            },
    
            getUltimaFrazione(item, tailNum = 1, riduci = true) {
                if (this.isMultilap()) {
                    if (item && item.rilevamenti) {
                        let numLaps = item.rilevamenti[1].length;
                        if (tailNum <= numLaps) {
                            if (riduci)
                                return this.riduci(item.rilevamenti[1][numLaps - tailNum]['fraz']);
                            else 
                                return (item.rilevamenti[1][numLaps - tailNum]['fraz']);
                        }
                    }
                } else {
                    if (item && item.rilevamenti) {
                        for (let index = (this.configEvento.numSplit); index > 0; index--) {
                            if (this.isMultilap()) {
                                let numLaps = item.rilevamenti[index].length;
                                if (tailNum <= numLaps) {
                                      if (riduci)
                                    return this.riduci(item.rilevamenti[index][numLaps - tailNum]['fraz']);
                                else 
                                    return (item.rilevamenti[index][numLaps - tailNum]['fraz']);
    
                                }
                            }
                        }
                    }
                }
                return undefined;
            },
    
            getMinTempo(item) {
                if (item && item.rilevamenti) {
                    const listaRil = item.rilevamenti[1];
                    if (listaRil.length > 0) {
                        let min = listaRil.reduce(function (prev, curr) {
                            return prev.fraz < curr.fraz ? prev : curr;
                        });
                        return this.riduci(min.fraz);
                    }
                }
                return undefined;
            },
    
            getMaxTempo(item) {
                if (item && item.rilevamenti) {
                    const listaRil = item.rilevamenti[1];
                    if (listaRil.length > 0) {
                        let min = listaRil.reduce(function (prev, curr) {
                            return prev.fraz > curr.fraz ? prev : curr;
                        });
                        return this.riduci(min.fraz);
                    }
                }
                return undefined;
            },
    
            isWarningCell(item, tailNum = 1) {
                if (item && item.rilevamenti) {
                    let numLaps = item.rilevamenti[1].length;
                    if (tailNum <= numLaps) {
                        return item.rilevamenti[1][numLaps - tailNum]['warning']
                    }
                }
                return undefined;
            },
    
            setCurrentItem(item, colDef) {
                //console.log("setCurrentItem")
                //console.log(item)
                //console.log(colDef)
                this.currentItem = item;
    
                if (colDef !== undefined && colDef.columnName == 'col_bands') {
                    this.setCurrentBands(item);
                    return;
                }
    
                this.currentRilevamenti = [];
                if (item.rilevamenti[1] !== undefined) {
                    this.currentRilevamenti = item.rilevamenti[1];
                }
                this.dettaglio = true;
            },
    
            orderBy(field) {
                console.log("Order by " + field)
    
                if (this.orderByField === field) {
                    this.direction = !this.direction;
                } else {
                    this.direction = true;
                    this.orderByField = field;
                }
                this.itemsF = this.filteredList();
            },
    
            changedLabel(event) {
                console.log('Changed:' + event);
                this.categoriaSelected = event;
    
                this.itemsF = this.filteredList();
            },
            changedSex(event) {
               // console.log('Changed:' + event);
                this.sessoSelected = event;
    
                this.itemsF = this.filteredList();
            },
    
            changedDivisione(event) {
                this.divisioneSelected = event;
                this.itemsF = this.filteredList();
            },
    
            changedSearch(event) {
              //  console.log('Changed:' + event);
                this.searchText = event;
    
                this.itemsF = this.filteredList();
            },
    
            changedCategoria(event) {
               // console.log('Changed:' + event);
                this.categoriaSelected = event;
    
                this.itemsF = this.filteredList();
            },
            changedNazione(event) {
                this.nazioneSelected = event;
                this.itemsF = this.filteredList();
            },
    
            annullaFiltro() {
                this.sessoSelected = "TUTTI";
                this.categoriaSelected = "TUTTE";
                this.divisioneSelected = "TUTTE";
                 this.nazioneSelected = "TUTTE";
                this.filtroDialog = false;
                this.itemsF = this.filteredList();
            },
    
            isChecked(pett) {
                console.log('is checked');
                return (
                    this.listaPreferiti[pett] !== undefined &&
                    this.listaPreferiti[pett] == pett
                );
            },
    
            refresh: function (self) {
                if (self.pause) return;
                self.currentIndex = 1;
                self.value = 0;
                self.numRilevamentiStep = 0;
                self.execute(self);
            },
    
            refreshBar: function (self) {
                if (self.pause) return;
                if (self.value == undefined) self.value = 0;
                // console.log("refreshBar :" + self.value)
                self.value += (100 / (self.refreshData / 1000));
                //console.log(self.value);
                if (self.value > 100) self.value = 0;
    
                const now = dayjs(new Date()).format('HH:mm:ss');
                this.raceTime = this.diffTime(now, this.configEvento.gunTime)
            },
    
            forceReload() {
                this.refresh(this);
            },
    
            getBatterie(){
                let lista = [];

                let listaBatt = Object.keys(this.configEvento).filter( line => { return line.startsWith("batteria")} );
                listaBatt.forEach( div => {
                    const nome = div.replaceAll('batteria','');
                    if (nome !== '') {
                        let values = this.configEvento['batteria'+nome].split(",")
                        lista.push({
                                name: nome,
                                guntime: values[0],
                                finishtime: values[1],
                                color: this.configEvento['colorBatteria'+nome],
                        });
                    } 
                })
                return lista;
            },

            getSplits(){
                let lista = [];
                let index = 1;
                while (true){
                    if ( this.configEvento['split'+index] !== undefined && this.configEvento['split'+index] !== ''  ){
                        lista.push({pos: index, 
                            titolo: this.configEvento['titolo'+index],
                            numLap: this.configEvento['numLap'+index],
                            valTime: this.configEvento['valTime'+index],
                            cutFrom: this.configEvento['cutFrom'+index],
                            cutTo: this.configEvento['cutTo'+index],
                            tagFileRef: this.configEvento['tagFileRef'+index],
                            type: this.configEvento['type'+index], 
                            loop: this.configEvento['loop'+index], 
                            channel: this.configEvento['channel'+index], 

                        })
                        index++;
                    } else {
                        break;
                    }
                }
                return lista;
            },

            removeUndefined( value ){
                if (value == undefined) return "";
                return value;
            },
    
            execute(self) {

                if (!this.isPageVisible) {
                    console.log("Pagina in secondo piano. non richiamo aggiornamenti")
                    return;
                }


                let _getFile = "getFileTagAttivoEvol";

                let mappa = "";
                this.listaSplit.forEach( split => {

                    let num =  this.mappaFiles[split.pos];
                    if (num == undefined) {
                        this.mappaFiles[split.pos] = 0;
                        num = 0;
                    }
                    mappa = mappa + split.pos+"="+num+","
                })

                const _url = this.getTagsURL() + _getFile +"?mappa=" + mappa + "&idGara=" + this.raceID + "&id=" + this.paramID;
                console.log("EXECUTE NEW:" + _url);
    
                self.getCall(_url).then( (response) => {
                    if (response.versionC != this.versionC || response.versionP != this.versionP ) {
                            this.refreshAll();
                        }else {
                            let listaResponse =(response.delta)
                            if (listaResponse.length > 0) {
                                listaResponse.forEach( _response => {
                                    let fileX = _response['content']
                                    //console.log(fileX.length);
                                    fileX = fileX.replaceAll("|","\n");
    
                                    this.currentIndex = _response['ref']
    
                                    if (fileX.length > 0) {
                                        fileX = "tag;clock;antenna;progr\n" + fileX;
                                        let numRilSplit = this.popolaPassaggi(fileX).length;
                                        this.numRilevamentiStep += numRilSplit;
                                        console.log("NUM RIL:"  +   _response['ref'] + " == " + numRilSplit)
                                    }
    
                                })
    
                            }
    
                            if (this.numRilevamentiStep > 0) 
                                this.showClassifica(self);

                        }
                    }
                ).catch(
                    (error) => {
                        console.log("Errore " + error);
                        
                    });
    
            },


            compareField(a, b, fieldName = null) {
    
                if (fieldName == null) fieldName = this.orderByField;
                if (fieldName == 'atleta') fieldName = 'cognome';
    
                const molti = this.direction ? 1 : -1;
    
                let valoreA = a[fieldName];
                let valoreB = b[fieldName];
    
                if (valoreA === undefined && valoreB == undefined) return 0;
                else if (valoreA === undefined) {
                    return -1 * molti;
                } else if (valoreB === undefined) {
                    return 1 * molti;
                }
    
                if (!isNaN(valoreA) && !isNaN(valoreB)) {
                    valoreA = parseFloat(valoreA);
                    valoreB = parseFloat(valoreB);
                }
    
                if (valoreA < valoreB) {
                    return -1 * molti;;
                }
                if (valoreA > valoreB) {
                    return 1 * molti;;
                }
                return 0;
            },
    
            compareRil(a, b, fieldName, index = 1) {
                if (a.rilevamenti[index].length === b.rilevamenti[index].length) {
                    if (a.rilevamenti[index].length == 0) return 0;
                    //const tempoA = a.rilevamenti[index][a.rilevamenti[index].length - 1].time;
                    //console.log(a);
                    //console.log(b);
                    //const tempoB = b.rilevamenti[index][b.rilevamenti[index].length - 1].time;
                    let tempoA = a[fieldName + index];
                    let tempoB = b[fieldName + index];
    
                    if (this.isMultilap()) {
                        tempoA = a.rilevamenti[index][a.rilevamenti[index].length - 1].time;
                        tempoB = b.rilevamenti[index][b.rilevamenti[index].length - 1].time;
                    }
    
                    //console.log("COMPARE:" +  a.rilevamenti[index].length + " - " + b.rilevamenti[index].length +" - " + tempoA + " " + tempoB);
    
                    if (tempoA === undefined && tempoB == undefined) return 0;
                    else if (tempoA === undefined) {
                        return -1
                    } else if (tempoB === undefined) {
                        return 1
                    }
    
                    if (tempoA < tempoB) {
                        return -1;
                    }
                    if (tempoA > tempoB) {
                        return 1;
                    }
                    return 0;
                } else {
                    return (b.rilevamenti[index].length - a.rilevamenti[index].length)
                }
            },
    
    
            compareRilUltra(a, b) {
                let tempoA = this.getFieldValue(b, {fieldType: 'distanza'})
                let tempoB = this.getFieldValue(a, {fieldType: 'distanza'})
    
                if (tempoA === undefined && tempoB == undefined) return 0;
                else if (tempoA === undefined) {
                    return -1
                } else if (tempoB === undefined) {
                    return 1
                }
    
               if (parseFloat(tempoA) < parseFloat(tempoB)) {
                 //console.log(tempoA+" -- " + tempoB+ " = -1")
                return -1;
                }
                if (parseFloat(tempoA) > parseFloat(tempoB)) {
                    //console.log(tempoA+" -- " + tempoB+ " = 1")

                    return 1;
                }
    
                return this.compareRil(a, b, 'tempo',  1) 
    
            },
    
            compare(a, b) {
                if (this.configEvento.criterioClass !== undefined && this.configEvento.criterioClass === 'bib') {
                    return parseFloat(a.pett) - parseFloat(b.pett);
                } else {
                    for (let index = (this.configEvento.numSplit); index > 0; index--) {
                        let res = this.compareRil(a, b, index);
                        if (res != 0) return res;
                    }
                }
            },


            sexCompare(a, b, fieldName = 'participant.sesso') {
                let molti = 1;
                let filtroTok = fieldName.split(".")

                let valoreA = a[filtroTok[0]][filtroTok[1]];
                let valoreB = b[filtroTok[0]][filtroTok[1]];

                if (valoreA === undefined && valoreB == undefined) return 0;
                else if (valoreA === undefined) {
                    return -1 * molti;
                } else if (valoreB === undefined) {
                    return 1 * molti;
                }

                if (valoreA < valoreB) {
                    return -1 * molti;;
                }
                if (valoreA > valoreB) {
                    return 1 * molti;;
                }
                return 0;
            },      


            catCompare(a, b, fieldName = 'categoria') {

                console.log("catCompare")

               // return this.compareField(a, b, 'cat')
                let res = this.compareField(a, b, 'sesso')
                if (res != 0) return res;

                let molti = 1;

                let valoreA = a[fieldName];
                let valoreB = b[fieldName];

                let filtroTok = fieldName.split(".")
                if (filtroTok.length == 2) {
                    valoreA = a[filtroTok[0]][filtroTok[1]];
                    valoreB = b[filtroTok[0]][filtroTok[1]];
                }

                if (valoreA === undefined && valoreB == undefined) return 0;
                else if (valoreA === undefined) {
                    return -1 * molti;
                } else if (valoreB === undefined) {
                    return 1 * molti;
                }

                if (valoreA < valoreB) {
                    return -1 * molti;;
                }
                if (valoreA > valoreB) {
                    return 1 * molti;;
                }
                return 0;
            },

    
            compareClassifica(a, b) {
                const statoDiff = this.statoOrdine[a.stato_atleta] - this.statoOrdine[b.stato_atleta];
                if (statoDiff !== 0) {
                    return statoDiff;
                }else {
                    if (a.stato_atleta === "-" && b.stato_atleta === "-") {
                        if (this.configEvento.criterioClass === undefined) {
                            if (this.isUltra()) {
                                return this.compareRilUltra(a, b);
                            } else if (this.isMultilap()) {
                                return this.compareRil(a, b, 'tempo', 1);
                            } else {
                                if (this.segment == 'LIVE') {
                                    for (let index = (this.configEvento.numSplit); index > 0; index--) {
                                        let res = this.compareRil(a, b, 'tempo', index);
                                        if (res != 0) return res;
                                    }
                                }else{
                                    console.log(this.configEvento)
                                    let numSplit = this.configEvento.numSplit;
                                    numSplit = parseInt(this.mappaSplit[this.mappaSplitLabel[this.segment]])
                                    //console.log("numSplit >>" + numSplit)
                                    return this.compareRil(a, b, 'tempo', numSplit);

                                }
                            }
                        } else {
                            let criterio = this.configEvento.criterioClass.split(",");
                            let res = 0;
                            for (let j=0; j< criterio.length; j++ ) {
                                //this.orderByField = criterio[j];
                                if (criterio[j] ==='tempo'){
                                    console.log("CLASSIFICA CON CRITERIO: " + criterio[j]+ " >> " + res)
                                    for (let index = (this.configEvento.numSplit); index > 0; index--) {
                                        res = this.compareRil(a, b, 'tempo', index);
                                        if (res != 0) return res;
                                    }
                                } else {
                                    res = this.compareField(a, b, criterio[j])
                                    console.log("Stesso valore: " + criterio[j]+ " >> " + res)
                                    if (res != 0) return res;
                                }
                            }
                        }
                    }
                }
            },
    
    
            simpleCompare(a, b) {
                return this.compareField(a, b)
            },
    
            clockCompare(a, b) {
                return this.compareField(a, b, 'lastClock')
            },
    
            showClassifica(self) {
                console.log("show Classifica")
    
                let mappaPosClassifica = {};
    
                let clockPrimo = null;
                let clockUltimo = null;
    
                let posAss = 1;
                let posM = 1;
                let posF = 1;
    
                let mappaQualif = {};
    
                this.elencoIscritti.sort(this.compareClassifica);
                this.elencoIscritti.forEach(elem => {

                    elem.starred = this.mapStars[elem.pett] != undefined && this.mapStars[elem.pett] == true


                    if (elem.stato_atleta == 'DNS'   ) {
                        elem.posAss = "-";
                        elem.posMF = "-";
                        elem.posCat = "-"
                        return;
                    } else if ( elem.stato_atleta == 'DSQ' || elem.stato_atleta == 'DNF' ) {
                        elem.posAss = "-";
                        elem.posMF = "-";
                        elem.posCat = "-"
                        //return;
                    }

                    let keyPos = "DIV_" + elem.divisione + "_" + elem.sesso;
                    let counterPos = mappaPosClassifica[keyPos];
                    if (counterPos == undefined) {
                        mappaPosClassifica[keyPos] = 1;
                    } else {
                        mappaPosClassifica[keyPos] = counterPos + 1;
                    }
                    elem.posDiv = mappaPosClassifica[keyPos];
                    elem.posAss = posAss++;
    
                    if (elem.sesso === 'F') {
                        elem.posMF = posF++;
                    } else {
                        elem.posMF = posM++;
                    }
    
                    keyPos += "_CAT_" + elem.categoria;
                    counterPos = mappaPosClassifica[keyPos];
                    if (counterPos == undefined) {
                        mappaPosClassifica[keyPos] = 1;
                    } else {
                        mappaPosClassifica[keyPos] = counterPos + 1;
                    }
                    elem.posCat = mappaPosClassifica[keyPos];
    
                    if (this.isMultilap()) {
                        let indexRil = 0;
                        elem.rilevamenti[1].forEach(rilev => {
                            const warn = this.isWarning(elem.rilevamenti[1], rilev, indexRil);
                            rilev.warning = warn;
                            if (warn) elem.warning = true;
                            indexRil++;
                        })
                    }
    
                    if (this.showMedia) {
                        elem.media = this.calcolaMedia(elem.tempo, elem.distanzaDivisione, this.configEvento.unitaMedia);
                    }
    
                    if (this.showGap) {
                        if (this.isMultilap()) {
                            
                            
                            if (clockPrimo == null) {
                                console.log("Primo")
                                //elem.distacco1 = elem.tempo;
                                elem.distacco1 = ""
                                elem.distacco2 = "";
                                clockPrimo = elem.lastTime;
                                  
                                
                            } else {
                                if (elem.lastTime > clockPrimo) {
                                    elem.distacco1 = "+" + this.riduci(this.diffTime(elem.lastTime, clockPrimo, this.configEvento.gapFormat));
                                } else {
                                    elem.distacco1 = "-";
                                }
                                if (elem.lastTime >= clockUltimo) {
                                    elem.distacco2 = "+" + this.riduci(this.diffTime(elem.lastTime, clockUltimo, this.configEvento.gapFormat));
                                } else {
                                    elem.distacco2 = "-";
                                }
                            }
                            clockUltimo = elem.lastTime;
    
                                
                                
                        } else {
                            const tempoSegmento = this.getTempoSegmento(elem);
                            if (clockPrimo == null) {
                                console.log("Primo")
                                //elem.distacco1 = elem.tempo;
                                elem.distacco1 = ""
                                elem.distacco2 = "";
                                clockPrimo = tempoSegmento;
                                if (this.isMultilap()) {
                                    clockPrimo = elem.lastTime;
                                }
                            } else {
                                if (tempoSegmento > clockPrimo) {
                                    elem.distacco1 = "+" + this.riduci(this.diffTime(tempoSegmento, clockPrimo, this.configEvento.gapFormat));
                                } else {
                                    elem.distacco1 = "-";
                                }
                                if (tempoSegmento >= clockUltimo) {
                                    elem.distacco2 = "+" + this.riduci(this.diffTime(tempoSegmento, clockUltimo, this.configEvento.gapFormat));
                                } else {
                                    elem.distacco2 = "-";
                                }
                            }
                            clockUltimo = tempoSegmento;
    
                        }
    
                        
                    }

                    let numQ = Object.keys(mappaQualif).length;
                        if (numQ < this.numQualif) {
    
                            if (mappaQualif[elem.tessera] == undefined) {
                                elem.qualif = "QUAL"
                                mappaQualif[elem.tessera] = "QUAL"
                            } else  {
                                elem.qualif = ""
                            }
                        }else {
                            elem.qualif = ""
                        }


                        let indexLeg = 1;
                        while (true) {
                            if (this.configEvento['leg'+indexLeg] != undefined) {
                                console.log("leg>>>")
                                const leg = this.configEvento['leg' + indexLeg];
                                if (leg !== undefined) {
                
                                    const _leg = leg.replaceAll(" ", ",").replaceAll(";", ",").replaceAll("\t", ",").replaceAll(",,",",").replaceAll(",,",",").replaceAll(",,",",").replaceAll(",,",",").replaceAll(",,",",");
                                    const toks = _leg.split(",");
                                    let legName = "";
                                    let legFrom = ""; 
                                    let legTo = "";
                
                                    toks.forEach(tok => {
                                        if (tok.indexOf("=") !== -1) {
                                            const keyval = tok.split("=");
                                            if(keyval[0].startsWith('leg')) {
                                                legName = keyval[1]  
                                            } else  if (keyval[0] == 'from') {
                                                legFrom  = keyval[1] 
                                            } else  if (keyval[0] == 'to') {
                                                legTo  = keyval[1] 
                                            }
                                        }
                                    })

                                    let t0 = elem['clock'+this.mappaSplit[legFrom]];
                                    if (legFrom == 'GUNTIME') t0 = elem.guntime;
                                    let t1 = elem['clock'+this.mappaSplit[legTo]];
                                    if (t1 != undefined && t0 != undefined) {
                                        elem['leg' + indexLeg] = this.diffTime(t1, t0, "HH:mm:ss.SSS");
                                    }
                                }
                                indexLeg++;
                            }else {
                                break;
                            }
                        }

                        let indexFormula = 1;
                        while (true) {
                            if (this.configEvento['formula'+indexFormula] != undefined) {
                                const formula = this.configEvento['formula' + indexFormula];
                                if (formula !== undefined) {
                                    const { evaluate, boolean } = require('mathjs')
                                    const operatios = /[+\-\*\/\(\)]/g;
                                    let keys = formula.split(operatios);

                                    let scope =  {}
                                    let self = this;
                                    let valid = true;
                                    keys.forEach(function(k) {
                                        if (k && elem[k] !== undefined) {
                                            scope[k] = dayjs(self.getIsoDate(self.normalizzaTS(self.getTime(elem[k])))).utc().valueOf()+ 3600000;
                                        } else {
                                            valid = false;
                                        }
                                    });

                                    if (valid && keys.length == Object.keys(scope).length){
                                        var answer = (evaluate(formula, scope)) // {"x": 3, "y": 4}
                                        const _ans = dayjs( new Date(answer)).utc().format("HH:mm:ss");
                                        elem['formula' + indexFormula] = _ans
                                    }
                                }
                                indexFormula++;
                            }else {
                                break;
                            }
                        }

                });
    
                self.items = this.elencoIscritti;
                self.itemsF = this.filteredList();
    
            },
    
            isRilevamentoValido(listaRilevamentiAtleta, clock, idPassaggio, laps, guntime, finishTime, winnerTime) {
                
                const t1 = dayjs(this.normalizzaTS(this.getTime(clock)));
                const tGUN = dayjs(this.normalizzaTS(this.getTime(guntime)));

                if (this.configEvento['type' + idPassaggio] !== undefined && this.configEvento['type' + idPassaggio] == 'spunta') {
                    return true;
                }

                if (t1.valueOf() < tGUN.valueOf()) return false;

                if (finishTime !== undefined && finishTime !== '') {
                    const tFinish = dayjs(this.normalizzaTS(this.getTime(finishTime)));
                    if (t1.valueOf() > tFinish.valueOf()) return false;
                }
    
                let valTime = 0;
                if (this.configEvento['valTime' + idPassaggio] !== undefined) {
                    valTime = parseInt(this.configEvento['valTime' + idPassaggio]) * 1000;
                }
                if (listaRilevamentiAtleta.length == 0) {
                    if (t1.valueOf() - tGUN.valueOf() < valTime) {
                           return false;
                    }
                    return true;
                }
    
                if (this.configEvento['type' + idPassaggio] !== undefined && this.configEvento['type' + idPassaggio] == 'last') {
                    return true;
                }
    
    
                if (listaRilevamentiAtleta.length < laps) {
    
                    let valTime = 0;
                    if (this.configEvento['valTime' + idPassaggio] !== undefined) {
                        valTime = parseInt(this.configEvento['valTime' + idPassaggio]) * 1000;
                    }
                    let ultimoPassaggio = this.getTime(listaRilevamentiAtleta[listaRilevamentiAtleta.length - 1].clock);
                    //if (ultimoPassaggio.indexOf(".") == -1) ultimoPassaggio += ".000";
    
                    const t0 = dayjs(this.normalizzaTS(ultimoPassaggio)).utc();
                    const t1 = dayjs(this.normalizzaTS(this.getTime(clock))).utc();
    
                    if (winnerTime !== undefined) {
                        const tWinner = dayjs(this.normalizzaTS(winnerTime)).utc();
                        if (t0.valueOf() > tWinner.valueOf()) return false;
                    }
    
                    //console.log(tempoOrig);
                    const diff = t1.valueOf() - t0.valueOf();
                    if (diff >= valTime) {
                        return true;
                    } else {
                        //if (this.configEvento.debug) {
                        console.log("Valtime > " + valTime);
                        console.log(ultimoPassaggio + " > " + t0.valueOf());
                        console.log(this.getTime(clock) + " > " + t1.valueOf());
                        console.log("DIFF:" + diff);
                        // }
                    }
                } else {
                    console.log("Scarto numLap superiori a quelli ammessi nel passaggio  ");
                }
                return false;
            },
    
            popolaPassaggi(data) {
                let index = this.currentIndex;
                console.log("popolaPassaggi>" + index);
    
                let lista = this.csvJSON(data);
                console.log("aggiungo >" + lista.length + " letture");
                if (this.configEvento.debug) console.log("aggiungo >" + JSON.stringify(lista));
                this.mappaFiles[index] += lista.length;
    
                let result = [];
    
                lista.forEach(elem => {
                    if (elem.clock === undefined) {
                        //console.log("Time " + elem.clock + " is before cut: " + cutFrom);
                    } else {

                        let laps = 1;
                        if (this.configEvento['numLap' + index] !== undefined) {
                            laps = parseInt(this.configEvento['numLap' + index]);
                        }
    
                        let p = this.chipMap[elem['tag']];
                        if (p !== undefined) {
                            let pettorale = p['pett'];
    
                            if (this.mappaDivisioni[p.divisione] !== undefined && this.mappaDivisioni[p.divisione]['numGiri'] > 0) {
                                laps = this.mappaDivisioni[p.divisione]['numGiri']
                            }
    
                            let _finishTime = p.finishtime;
                            //console.log("FINISH TIME>" + _finishTime + "<")
                            if ((_finishTime === '' || _finishTime == undefined) && this.configEvento['finishTime' + p['divisione']] !== undefined) {
                                _finishTime = this.raceDate+"-"+ this.configEvento['finishTime' + p['divisione']];
                            }
    
                            let _winnerTime = this.configEvento.winnerTime;
                            if (this.configEvento['winnerTime' + p['divisione']] !== undefined) {
                                _winnerTime = this.raceDate+"-"+ this.configEvento['winnerTime' + p['divisione']];
                            }
    
                            if (this.isRilevamentoValido(p.rilevamenti[index], elem.clock, index, laps, p.guntime, _finishTime, _winnerTime)) {
                                //console.log("DEBUG:>>");
                                
    
                                if (index == 1 && this.isRealTime()) {
                                    p.guntime = elem.clock
                                }
    
                                const _tempo = this.getTempo(p.guntime, elem.clock);
                                const _clock = elem.clock; //this.getTime(elem.clock);
                                let _fraz = (this.diffTime(elem.clock, p.guntime, this.configEvento.frazFormat));
    
    
                                if (this.configEvento['type' + index] !== undefined && this.configEvento['type' + index] === 'last') {
                                    console.log("LAST:" + this.configEvento['type' + index])
                                    let obj = {
                                        pett: p.pett,
                                        time: _tempo,
                                        clock: _clock,
                                        fraz: _fraz,
                                        lap: 1
                                    }
    
                                    if (p.rilevamenti[index].length == 0)
                                        p.rilevamenti[index].push(obj);
                                    else
                                        p.rilevamenti[index][0] = obj;
    
                                } else {
    
                                    if (this.isMultilap()) {
                                        if (p.rilevamenti[index].length > 0) {
                                            _fraz = (this.diffTime(_tempo, p.rilevamenti[index][p.rilevamenti[index].length - 1].time , this.configEvento.frazFormat));
                                        }
                                    } else {
                                        if (index > 1 && p.rilevamenti[index - 1].length > 0) {
                                            _fraz = (this.diffTime(_tempo, p.rilevamenti[index - 1][p.rilevamenti[index - 1].length - 1].time, this.configEvento.frazFormat));
                                        }
                                    }
    
                                    p.rilevamenti[index].push({
                                        pett: p.pett,
                                        time: _tempo,
                                        clock: _clock,
                                        fraz: _fraz,
                                        lap: p.rilevamenti[index].length + 1
                                    });
                                }
    
                                if (p.rilevamenti[index].length == laps) {
    
                                    //if (laps > 1 ) console.log("PASSAGGI CORRETTI:" + p.cognome + " " + p.pett)
                                    p.clock = this.getTime(elem.clock);
                                    p.tempo = this.getTempo(p.guntime, elem.clock)
    
                                    p['tempo' + index] = this.getTempo(p.guntime, elem.clock);
                                    p['clock' + index] = _clock;
                                    p['fraz' + index] = _fraz; // this.getTime(_fraz);
                                }
    
                                p.lastClock = _clock;
                                p.lastTime = _tempo;
                                p.laps = p.rilevamenti[index].length;
    
                                result.push(p);
                            } else {
                                console.log("passaggio non valido:" + elem.tag + " " + p.cognome + " " + elem.clock + " >>" + JSON.stringify(p.rilevamenti[index]));
                            }
                        } else {
                            if (this.configEvento.debug) console.log("Tag " + elem.tag + " sconosciuto");
                        }
    
                    }
    
                })
    
                this.mappaIntermedi[index] += result.length;
                return result;
    
            },
    
            isWarning(listaRil, rilevamento, indexRil) {
                if (listaRil.length > 1) {
                    var utc = require('dayjs/plugin/utc')
                    dayjs.extend(utc)
    
                    let ttMin = undefined;
                    if (indexRil == 0) return false;
    
                    let indexFrom = indexRil;
                    let indexTo = indexFrom + this.warningLaps;
    
                    if (indexRil < this.warningLaps) {
                        indexFrom = 0;
                        indexTo = indexRil;
                    } else {
                        indexFrom = indexRil - this.warningLaps;
                        indexTo = indexRil;
                    }
                    //alert(minVal)
    
                    let last5 = listaRil.slice(indexFrom, indexTo);
                    //console.log("da: " + (indexFrom) + " a: " + (indexTo) );
    
                    let min = last5.reduce(function (prev, curr) {
                        //console.log(rilevamento.pett + " >> " + prev.fraz + " - " + curr.fraz);
                        return prev.fraz < curr.fraz ? prev : curr;
                    });
                    ttMin = min.fraz
                    //console.log("WINNER >> " + ttMin)
    
                    const tt0 = this.normalizzaTS(rilevamento.fraz);
                    const tt1 = this.normalizzaTS(ttMin);
    
                    const t0 = dayjs(this.getIsoDate(tt0)).utc() + 3600000;
                    const tMin = dayjs(this.getIsoDate(tt1)).utc() + 3600000;
    
                    if ((t0.valueOf()) > ((tMin.valueOf()) * this.warningDelta)) {
                        return true;
                    }
    
                }
                return false;
            },
    
            getTempo(guntime, tempoRil) {
                var utc = require('dayjs/plugin/utc')
                dayjs.extend(utc);
    
                const tt0 = this.normalizzaTS(guntime);
                const tt1 = this.normalizzaTS(tempoRil);
    
                //console.log("getTempo: " + tt0+" "+ tt1);
    
                const t0 = dayjs(this.getIsoDate(tt0)).utc();
                const t1 = dayjs(this.getIsoDate(tt1)).utc();
    
                var duration = (t1.diff(t0));
                let result = dayjs(duration).utc().format("HH:mm:ss.SSS");
    
                //console.log(">getTempo: " +result);
    
                if (result === 'Invalid Date') return tempoRil;
    
                return result;
            },
    
            gotoHome() {
                this.$router.push('/');
            },

           gotoSL() {
                const currentPath = this.$route.path; // es: "/remoteattivopublic/TEMPOZERO_liveConfigurationCRONO_M.txt/LIVE"
                const newPath = currentPath.replace(/^\/remoteattivopublic/, '/startinglist');
                this.$router.push(newPath);
            },
    
            gotoAdmin() {
                const currentPath = this.$route.path; // es: "/remoteattivopublic/TEMPOZERO_liveConfigurationCRONO_M.txt/LIVE"
                const newPath = currentPath.replace(/^\/remoteattivopublic/, '/remoteattivo');
                this.$router.push(newPath);
            },
    
            getStyle(index, n) {
                if (n != undefined) return n;
                if (index % 2 == 0) return "grey lighten-4"
                return "white"
            },
    
            getClasseFiltro() {
                if (this.categoriaSelected !== 'TUTTE' && this.categoriaSelected !== undefined && this.categoriaSelected !== '') {
                    return "red--text"
                } else if (this.divisioneSelected !== 'TUTTE' && this.divisioneSelected !== undefined && this.divisioneSelected !== '') {
                    return "red--text"
                } else if (this.nazioneSelected !== 'TUTTE' && this.nazioneSelected !== undefined && this.nazioneSelected !== '') {
                    return "red--text"
                } else if (this.sessoSelected !== 'TUTTI' && this.sessoSelected !== undefined && this.sessoSelected !== '') {
                    return "red--text"
                }
                return ''
            },
    
            toggleWarning() {
                this.onlyWarning = !this.onlyWarning;
                this.itemsF = this.filteredList();
            },
    
            toggleCompatta() {
                this.compatta = !this.compatta;
            },
    
            toggleSearch() {
                this.filterToggle = !this.filterToggle;
                window.scrollTo(0, 0);
            },
    
            togglePreferiti() {
                this.filterPreferiti = !this.filterPreferiti;
                this.showClassifica(this.raceData);
            },
            toggleItem(pett) {
                if (this.listaPreferiti[pett] == undefined) {
                    this.listaPreferiti[pett] = pett;
                } else {
                    this.listaPreferiti[pett] = undefined;
                }
                console.log(pett + '-->' + this.listaPreferiti[pett]);
                helper.ls.set(
                    'PREFERITI_' + this.$route.params.raceID,
                    this.listaPreferiti
                );
                //this.togglePreferiti();
                //this.togglePreferiti();
                //this.showClassifica(this.raceData);
            },
    
            filteredList() {
                var listaSearch = this.items;

                if (this.configEvento.showDNS !== undefined ) {
                    console.log("showDNS")
                    listaSearch = this.elencoIscritti

                    console.log(listaSearch.length)
                }


                if (this.searchText !== '' && this.searchText != null) {
                    listaSearch = this.items.filter((p) => {
                        let res =
                            p != null &&
                            p.cognome != null &&
                            p.cognome.toUpperCase().indexOf(
                                this.searchText.toUpperCase()
                            ) !== -1;
                        let res1 =
                            p != null &&
                            p.squadra != null &&
                            p.squadra.toUpperCase().indexOf(
                                this.searchText.toUpperCase()
                            ) !== -1;
    
                        let res2 =
                            p != null &&
                            p.pett != null &&
                            p.pett == this.searchText;
    
                        let resTot = res || res1 || res2;
                        return resTot;
                    });
                }

                if (this.starred) {
                    listaSearch = listaSearch.filter(p => {
                        return p.starred == true;
                    })
                }
    
    
                if (this.filtroQualif) {
                    console.log(" filtroQualif ATTIVO:" + this.filtroQualif)
                    listaSearch = listaSearch.filter((p) => {
                        return  "QUAL" === p.qualif;
                    })
                }
    
                if (this.categoriaSelected !== 'TUTTE') {
                    listaSearch = listaSearch.filter((p) => {
                        const _cat = this.categoriaSelected.substring(this.categoriaSelected.indexOf(" - ") + 3);
                        console.log(_cat)
                        var res4 =
                            p != null &&
                            p.categoria != null &&
                            p.categoria == _cat;
    
                        return res4;
                    });
                }
    
    
                 if (this.nazioneSelected !== 'TUTTE') {
                    listaSearch = listaSearch.filter((p) => {
                        var res4 =
                            p != null &&
                            p.nazione != null &&
                            p.nazione.toUpperCase() == this.nazioneSelected.toUpperCase();
    
                        return res4;
                    });
                }
    
                //        console.log('sessoSelected:' + this.sessoSelected);
    
                if (this.sessoSelected !== 'TUTTI') {
                    listaSearch = listaSearch.filter((p) => {
                        let sex = this.sessoSelected == 'MASCHILE' ? 'M' : 'F';
                        var res4 =
                            p != null &&
                            p.sesso != null &&
                            p.sesso == sex;
    
                        return res4;
                    });
                }
    
                //       console.log('divisioneSelected:' + this.divisioneSelected);
    
                if (this.divisioneSelected !== 'TUTTE') {
                    listaSearch = listaSearch.filter((p) => {
                        var res4 =
                            p != null &&
                            p.divisione != null &&
                            p.divisione == this.divisioneSelected;
    
                        return res4;
                    });
                }
    
                if (this.orderByField !== null) {
                    listaSearch.sort(this.simpleCompare);
                }
    
    
    
                if (this.onlyWarning) {
                    console.log("Cerco solo warning")
                    listaSearch = listaSearch.filter((p) => {
                        return p.warning;
                    })
                    console.log("Cerco solo warning: " + listaSearch.length)
                }
    
                if (this.filtraPosCat > 0) {
                    listaSearch = listaSearch.filter((p) => {
                        var res =
                            p != null &&
                            p.posCat <= this.filtraPosCat
    
                        return res;
                    });
                }

                if (!this.isMultilap()) {
                    if (this.segment != undefined ){
                        listaSearch = listaSearch.filter((p) => {
                            var res =
                                p != null &&
                                this.getTempoSegmento(p) != undefined
                            return res;
                        });
                    }
                    
                    if (this.segment == 'LIVE'){
                        let lastRaggr = undefined;
                        listaSearch.forEach( it => {
                            const ultPass = this.getUltimoPassaggio(it) ;
                                if (ultPass  != lastRaggr) {
                                    it.raggr = true;
                                    lastRaggr = ultPass
                                } else {
                                    it.raggr = false;
                                }
                        })
                    }
                }

                return listaSearch;
            },
    
            
            getDivisioni(){
                let lista = [];

                let listaDiv = Object.keys(this.configEvento).filter( line => { return line.startsWith("gunTime")} );
                listaDiv.forEach( div => {
                    const nomeDiv = div.replaceAll('gunTime','');
                    if (nomeDiv !== '') {
                        lista.push({
                                name: nomeDiv,
                                guntime: this.configEvento['gunTime'+nomeDiv],
                                finishtime: this.configEvento['finishTime'+nomeDiv],
                                color: this.configEvento['color'+nomeDiv],
                                distanza: this.configEvento['distanza'+nomeDiv],
                        });
                    } 
                })
                return lista;
            },

            getFields() {
                // if (!this.isMultilap()) {
                //console.log("getFields")
                if (this.fields && this.fields.length > 0) {
                    let lista = [];
                    this.fields.forEach(elem => {
                        let label = this.getFieldlabel(elem);;
                        elem = this.getFieldName(elem)
    
                        let _elem = elem.replace("FRAC_", "")
                        _elem = _elem.replace("CLOCK_", "")
                        _elem = _elem.replace("TIME_", "")
                        let fieldType = "tempo"
                        if (elem.startsWith("FRAC_")) {
                            fieldType = "fraz"
                        } else if (elem.startsWith("CLOCK_")) {
                            fieldType = "clock"
                        } else if (elem.startsWith("COL_") || elem.startsWith("GUNTIME") ||  elem.startsWith("leg") || elem.startsWith("formula")){
                            fieldType = "field"
                        } else if (elem.startsWith("metri")) {
                            fieldType = "distanza"
                            const _obj = {
                                splitNum: 0,
                                fieldType: fieldType,
                                columnName: elem,
                                label: label
                            };
                            // console.log(_obj)
                            lista.push(_obj);
                        }
    
                        if (fieldType == "field" ) {
                            const _obj = {
                                        splitNum: -1,
                                        fieldType: fieldType,
                                        columnName: elem.startsWith("COL_") ?  _elem.toLowerCase().substring(4): _elem.toLowerCase(),
                                        label: label
                                    };
                                    // console.log(_obj)
                                    lista.push(_obj);   
                        }else {
                            for (let index = (this.configEvento.numSplit); index > 0; index--) {
                                if (this.configEvento['titolo' + index] === _elem) {
                                    const _obj = {
                                        splitNum: index,
                                        fieldType: fieldType,
                                        columnName: elem,
                                        label: label
                                    };
                                    // console.log(_obj)
                                    lista.push(_obj);
                                }
                            }
                        }
                    })
                    return lista;
                }
                return this.listaIntermedi;
                //  } else {
                //      return this.listaIntermedi;
                //  }
            },


            doCommand(e) {

                console.log(">" + e.keyCode)
                let index = this.segments.indexOf(this.segment);
                if (e.keyCode == 37) {
                    // sinistra
                    if (index > 0) {
                        this.segment = this.segments[index - 1]
                    } else {
                        this.segment = this.segments[0]
                    }
                    this.changeSegment(this.segment)
                } else if (e.keyCode == 39) {
                    // destra
                    if (index < this.segments.length - 1) {
                        this.segment = this.segments[index + 1]
                    } else {
                        this.segment = this.segments[0]
                    }
                    this.changeSegment(this.segment)
                } else if (e.keyCode == 38) {
                    this.segment = "LIVE"
                    this.changeSegment(this.segment)
                }
            },

            handleGesture(event) {

                let touchendX = event.changedTouches[0].screenX;
                let touchendY = event.changedTouches[0].screenY;
                if (touchendX < touchstartX) {
                    console.log('Swiped Left');
                    this.doCommand({ keyCode: 37 })
                }

                if (touchendX > touchstartX) {
                    console.log('Swiped Right');
                    this.doCommand({ keyCode: 39 })
                }

                if (touchendY < touchstartY) {
                    console.log('Swiped Up');
                }

                if (touchendY > touchstartY) {
                    console.log('Swiped Down');
                }

                if (touchendY === touchstartY) {
                    console.log('Tap');
                }
            },

            changeSplit(direction) {
                if (direction == '+') {
                    this.doCommand({ keyCode: 39 })
                } else {
                    this.doCommand({ keyCode: 37 })
                }
            },


            changeSegment(selectObj) {
                this.items.forEach( elem => {
                    elem.raggr = false;
                })
                this.itemsF = this.filteredList();
                this.showClassifica(this)

            },


            getStato(val) {
                const valore = parseInt(val)

                if (valore == 9997 || valore == 999997) return "DSQ"
                else if (valore == 9998 || valore == 999998) return "DNF"
                else if (valore == 9999 || valore == 999999) return "DNS"
                return val

            },

            getStatoAtleta(val) {
                if (val != undefined && val != "-")
                    return val
                return undefined;
            },

            getColorStatoAtleta(val) {
                if (val != undefined && val != "-"){
                    if (val == 'DNF') return "statoAtleta orange black--text"
                    else if (val == 'DNS') return "statoAtleta lightgrey black--text"
                    else if (val == 'DSQ') return "statoAtleta red white--text"
                }
                return "";
            },

            formatValue(value, split) {

                if (value == '00:00:00.000' && split.type == 'Distacco') return ""

                if (split.type !== undefined && split.type !== null && split.type.toUpperCase().indexOf("TEMPO") !== -1 && value != '-' && value != undefined) {
                    return this.formatTimestamp(value, split.format);
                }
                if (value == undefined) return "";
                return value;
            },

            formatTime(value, sport) {
                console.log(value)

                if (value != undefined ) {
                    return this.riduci(this.formatTimestamp(value,this.configEvento.timeFormat));
                }

                if (value != undefined && sport == 'Running' && value.indexOf(".") != -1) {
                    let valueTok = value.split(".")
                    return this.riduci(valueTok[0])
                }
                return this.riduci(value);
            },



            showDetail(item) {
                this.setCurrentItem(item)
               // this.currentItem = item;
               // this.dettaglio = true;
            },


            getListaSeq(lista){
                console.log(this.segment)
               // console.log(lista)

               lista.forEach(it => {
                    it.raggr = false;
                })


                if (this.segment == 'LIVE') {
                    let lastRaggr = undefined;
                    lista.forEach(it => {
                        const ultPass = this.getUltimoPassaggio(it) ;
                        if (ultPass  != lastRaggr) {
                            it.raggr = true;
                            lastRaggr = ultPass
                        } else {
                            it.raggr = false;
                        }
                    })
                }


                return lista;
            },

            getTempoSegmento(item) {

                if (this.isMultilap()){
                    return this.getUltimoTempo(item)
                }else {
                    if (this.segment == 'LIVE') return item.tempo;
                    return item['tempo' + this.mappaSplit[this.mappaSplitLabel[this.segment]]]
                }
            },

            getValoreCampoSplit(item, campo, _segment) {
                //console.log(_segment)
                if (_segment == undefined) 
                    _segment = this.segment
                else {
                    let field = this.report.fields.find(seg => {
                        return seg.fieldSource == _segment
                    });
                    if (field) {
                        _segment = field.name
                    }
                }

                if ( item.rilevamenti.length > 0 ) {
                }

                if (item[campo] !== undefined) return item[campo];

                //return this.getUltimoTempo(item)
              
                return "-"


            },

            starToggle(item) {
                //console.log(item)
                if (this.mapStars[item.pett] !== undefined) {
                    this.mapStars[item.pett] = !this.mapStars[item.pett];
                } else {
                    this.mapStars[item.pett] = true;
                }
                helper.ls.set('ICRONSTARS' + this.raceID+"_"+this.paramID, this.mapStars);
                item.starred = !item.starred

                this.itemsF = this.filteredList()
                if (this.itemsF.length == 0) {
                    // alert("Nessun atleta nella lista dei preferiti. Selezionare almeno una stellina ")
                    this.starred = false
                }
                //this.checkReport()
            },

            showStarred() {
                this.starred = !this.starred
                this.itemsF = this.filteredList();

                if (this.itemsF.length == 0) {
                    alert("Nessun atleta nella lista dei preferiti. Selezionare almeno una stellina ")
                    this.starred = !this.starred
                    this.itemsF = this.filteredList();
                }

            },

            removeNull(lista) {
                let listaFilt = [];
                lista.forEach(it => {
                    let valoreA = this.getValue(this.orderByField, it);
                    //console.log(valoreA)
                    if (valoreA !== '-')
                        listaFilt.push(it)
                })

                return listaFilt;
            },




    
        },
    };
    </script>
    
    <style scoped>
    td {
        height: 10px !important;
        _background-image: linear-gradient(60deg, grey, lightgray);
    }
    
    table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
        padding: 0 10px;
    }
    
    .frazioniTitle {
        text-align: center;
        background-color: lightgrey;
        border-radius: 0px 0px 3px 3px;
    }
    
    .frazioniValue {
        text-align: center;
        background-color: white;
        border-radius: 0px 0px 3px 3px;
        border-bottom: 1px solid lightgray;
    }
    
    .frazioniValueR {
        text-align: right !important;
    }
    
    .frazioniTitleFinale {
        text-align: center;
        color: white;
        font-style: italic;
        _border: 1px solid lightgray;
        _border-radius: 0px 0px 7px 7px;
        _font-weight: bold;
    }
    
    .frazioniTitleFinaleDesk {
        text-align: center;
        color: white;
        font-style: italic;
        _border-radius: 0px 5px 5px 0px;
    }
    
    .frazioniTitleRow {
        text-align: center;
        background-color: lightgrey;
        _border-radius: 0px 0px 7px 7px;
    }
    
    .frazioniTitleRowDesk {
        text-align: center;
        background-color: lightgrey;
        _border-radius: 5px 0px 0px 5px;
    }
    
    .frazioniValueRow {
        text-align: center;
        background-color: rgb(243, 243, 243);
        _border-radius: 0px 0px 7px 7px;
    }
    
    .myButton {
        text-align: center;
        background-color: rgb(243, 243, 243);
        _border: 1px lightgrey solid;
        border-bottom: 1px grey solid;
        border-radius: 3px 3px 3px 3px;
        padding: 3px;
        margin: 2px;
    }

    .passaggio {
        background-color: lightgrey;
        text-align: center;
        color: green;
        font-style: italic;
        _border: 1px solid lightgray;
        border-radius: 5px 5px 5px 5px;
        _font-weight: bold;
    }
    
    .laps {
        text-align: center;
        color: white;
        font-style: italic;
    }
    
    .clock {
        background-color: #212121;
        text-align: center;
        color: white;
        font-style: italic;
    }
    
    .cardUp {
        background-color: #212121;
        color: white;
        _border: 1px solid lightgray;
        border-radius: 10px 10px 0px 0px;
    }
    
    .cardStatsHeader {
        background-color: #212121;
        color: white;
        border-radius: 10px 10px 0px 0px;
    }
    
    .cardStats {
        background-color: white;
        color: black;
        border: 2px solid lightgray;
        border-radius: 10px 10px 10px 10px;
    }

    .backColor {
        background-color: #0D3D58;
        color: white;
        text-align: center
    }

    .primaryColor {
        background-color: #006064;
        color: white;
        text-align: center
    }

    .statoAtleta {
        border-radius: 3px 3px 3px 3px;
    }
    </style>
    